/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VersionIndexRouteImport } from './routes/version/index'
import { Route as AuthenticateWelcomeSetPasswordRouteImport } from './routes/authenticate/welcome-set-password'
import { Route as AuthenticateResetPasswordRouteImport } from './routes/authenticate/reset-password'
import { Route as AuthenticatePasswordForgottenRouteImport } from './routes/authenticate/password-forgotten'
import { Route as AuthenticateLoginRouteImport } from './routes/authenticate/login'
import { Route as AppResourcesRouteImport } from './routes/app/resources'
import { Route as AppPersonalDutyRosterRouteImport } from './routes/app/personal-duty-roster'
import { Route as AppOutboxRouteImport } from './routes/app/outbox'
import { Route as AppOrchestraRouteImport } from './routes/app/orchestra'
import { Route as AppDutySchedulingRouteImport } from './routes/app/duty-scheduling'
import { Route as AppDutyRosterRouteImport } from './routes/app/duty-roster'
import { Route as AppDashboardRouteImport } from './routes/app/dashboard'
import { Route as AppContactsRouteImport } from './routes/app/contacts'
import { Route as AppBackgroundJobsRouteImport } from './routes/app/background-jobs'
import { Route as AppAdminSettingsRouteImport } from './routes/app/admin-settings'
import { Route as AppAccountRouteImport } from './routes/app/account'
import { Route as ContractSigningContractIdIndexRouteImport } from './routes/contract-signing/$contractId/index'
import { Route as AppResourcesIndexRouteImport } from './routes/app/resources/index'
import { Route as AppOrchestraIndexRouteImport } from './routes/app/orchestra/index'
import { Route as AppDutiesIndexRouteImport } from './routes/app/duties/index'
import { Route as AppContactsIndexRouteImport } from './routes/app/contacts/index'
import { Route as AppAdminSettingsIndexRouteImport } from './routes/app/admin-settings/index'
import { Route as AppAccountIndexRouteImport } from './routes/app/account/index'
import { Route as ContractSigningContractIdSignedRouteImport } from './routes/contract-signing/$contractId/signed'
import { Route as AuthenticateMfaSelectAuthenticationFactorRouteImport } from './routes/authenticate/mfa/select-authentication-factor'
import { Route as AuthenticateMfaCreateRouteImport } from './routes/authenticate/mfa/create'
import { Route as AppResourcesResourcesRouteImport } from './routes/app/resources/resources'
import { Route as AppResourcesResourceObjectsRouteImport } from './routes/app/resources/resource-objects'
import { Route as AppResourcesIdRouteImport } from './routes/app/resources/$id'
import { Route as AppMyRapportRouteImport } from './routes/app/my/rapport'
import { Route as AppMyCalendarSubscriptionsRouteImport } from './routes/app/my/calendar-subscriptions'
import { Route as AppMyAbsencesRouteImport } from './routes/app/my/absences'
import { Route as AppDutiesPrintRouteImport } from './routes/app/duties/print'
import { Route as AppDutiesLeaveRequestsRouteImport } from './routes/app/duties/leave-requests'
import { Route as AppDutiesAbsencesRouteImport } from './routes/app/duties/absences'
import { Route as AppContractsContractsRouteImport } from './routes/app/contracts/contracts'
import { Route as AppContractsApprovalsRouteImport } from './routes/app/contracts/approvals'
import { Route as AppContactsIdRouteImport } from './routes/app/contacts/$id'
import { Route as AppComChatRouteImport } from './routes/app/com/chat'
import { Route as AppArtSchedulesRouteImport } from './routes/app/art/schedules'
import { Route as AppArtProductionsRouteImport } from './routes/app/art/productions'
import { Route as AppArtActivitiesRouteImport } from './routes/app/art/activities'
import { Route as AppAdminSettingsUsersRouteImport } from './routes/app/admin-settings/users'
import { Route as AppAdminSettingsOrganisationRouteImport } from './routes/app/admin-settings/organisation'
import { Route as AppAdminSettingsInfoRouteImport } from './routes/app/admin-settings/info'
import { Route as AppAdminSettingsGlobalSettingsRouteImport } from './routes/app/admin-settings/global-settings'
import { Route as AppAdminSettingsDashboardRouteImport } from './routes/app/admin-settings/dashboard'
import { Route as AppAdminSettingsAutomaticBackgroundJobsRouteImport } from './routes/app/admin-settings/automatic-background-jobs'
import { Route as AppAdminSettingsAbsencesRouteImport } from './routes/app/admin-settings/absences'
import { Route as AppMyDutyRosterIndexRouteImport } from './routes/app/my/duty-roster/index'
import { Route as AppMyCalendarIndexRouteImport } from './routes/app/my/calendar/index'
import { Route as AppMyAbsencesIndexRouteImport } from './routes/app/my/absences/index'
import { Route as AppDutiesShiftsAndCastsIndexRouteImport } from './routes/app/duties/shifts-and-casts/index'
import { Route as AppDutiesOrchestraIndexRouteImport } from './routes/app/duties/orchestra/index'
import { Route as AppDutiesLeaveRequestsIndexRouteImport } from './routes/app/duties/leave-requests/index'
import { Route as AppDutiesAbsencesIndexRouteImport } from './routes/app/duties/absences/index'
import { Route as AppContractsContractsIndexRouteImport } from './routes/app/contracts/contracts/index'
import { Route as AppContractsApprovalsIndexRouteImport } from './routes/app/contracts/approvals/index'
import { Route as AppContactsCreateMemoIndexRouteImport } from './routes/app/contacts/create-memo/index'
import { Route as AppContactsCallIndexRouteImport } from './routes/app/contacts/call/index'
import { Route as AppContactsIdIndexRouteImport } from './routes/app/contacts/$id/index'
import { Route as AppComFeedsIndexRouteImport } from './routes/app/com/feeds/index'
import { Route as AppComChatIndexRouteImport } from './routes/app/com/chat/index'
import { Route as AppArtProductionsIndexRouteImport } from './routes/app/art/productions/index'
import { Route as AppArtActivitiesIndexRouteImport } from './routes/app/art/activities/index'
import { Route as AppAdminSettingsUsersIndexRouteImport } from './routes/app/admin-settings/users/index'
import { Route as AppAdminSettingsOrganisationIndexRouteImport } from './routes/app/admin-settings/organisation/index'
import { Route as AppAdminSettingsLoggingIndexRouteImport } from './routes/app/admin-settings/logging/index'
import { Route as AppAdminSettingsInfoIndexRouteImport } from './routes/app/admin-settings/info/index'
import { Route as AppAdminSettingsGlobalSettingsIndexRouteImport } from './routes/app/admin-settings/global-settings/index'
import { Route as AppAdminSettingsAutomaticBackgroundJobsIndexRouteImport } from './routes/app/admin-settings/automatic-background-jobs/index'
import { Route as AppAdminSettingsAbsencesIndexRouteImport } from './routes/app/admin-settings/absences/index'
import { Route as AuthenticateMfaIdValidateRouteImport } from './routes/authenticate/mfa/$id/validate'
import { Route as AuthenticateMfaIdRegisterRouteImport } from './routes/authenticate/mfa/$id/register'
import { Route as AppMyAbsencesSuccessfullySendRouteImport } from './routes/app/my/absences/successfully-send'
import { Route as AppMyAbsencesNewLeaveRequestRouteImport } from './routes/app/my/absences/new-leave-request'
import { Route as AppMyAbsencesIdRouteImport } from './routes/app/my/absences/$id'
import { Route as AppDutiesLeaveRequestsEventLogRouteImport } from './routes/app/duties/leave-requests/event-log'
import { Route as AppDutiesLeaveRequestsIdRouteImport } from './routes/app/duties/leave-requests/$id'
import { Route as AppContractsContractsIdRouteImport } from './routes/app/contracts/contracts/$id'
import { Route as AppComChatChatIdRouteImport } from './routes/app/com/chat/$chatId'
import { Route as AppArtProductionsIdRouteImport } from './routes/app/art/productions/$id'
import { Route as AppArtActivitiesIdRouteImport } from './routes/app/art/activities/$id'
import { Route as AppAdminSettingsUsersNewRouteImport } from './routes/app/admin-settings/users/new'
import { Route as AppAdminSettingsUsersIdRouteImport } from './routes/app/admin-settings/users/$id'
import { Route as AppAdminSettingsLoggingIdRouteImport } from './routes/app/admin-settings/logging/$id'
import { Route as AppAdminSettingsAutomaticBackgroundJobsTableRouteImport } from './routes/app/admin-settings/automatic-background-jobs/table'
import { Route as AppAdminSettingsAutomaticBackgroundJobsNewRouteImport } from './routes/app/admin-settings/automatic-background-jobs/new'
import { Route as AppAdminSettingsAutomaticBackgroundJobsIdRouteImport } from './routes/app/admin-settings/automatic-background-jobs/$id'
import { Route as AppAdminSettingsAbsencesNewRouteImport } from './routes/app/admin-settings/absences/new'
import { Route as AppAdminSettingsAbsencesIdRouteImport } from './routes/app/admin-settings/absences/$id'
import { Route as AppContractsApprovalsContractIdIndexRouteImport } from './routes/app/contracts/approvals/$contractId/index'
import { Route as AppComFeedsFeedIdIndexRouteImport } from './routes/app/com/feeds/$feedId/index'
import { Route as AppArtProductionsIdIndexRouteImport } from './routes/app/art/productions/$id/index'
import { Route as AppAdminSettingsUsersNewIndexRouteImport } from './routes/app/admin-settings/users/new/index'
import { Route as AppDutiesLeaveRequestsDebugViewIdRouteImport } from './routes/app/duties/leave-requests/debug-view/$id'
import { Route as AppContractsApprovalsContractIdSignedRouteImport } from './routes/app/contracts/approvals/$contractId/signed'
import { Route as AppComFeedsFeedIdPostIdRouteImport } from './routes/app/com/feeds/$feedId/$postId'
import { Route as AppAdminSettingsUsersNewUsersForPersonsRouteImport } from './routes/app/admin-settings/users/new/users-for-persons'
import { Route as AppAdminSettingsUsersNewUserForPersonRouteImport } from './routes/app/admin-settings/users/new/user-for-person'
import { Route as AppAdminSettingsUsersNewExternalServiceUserRouteImport } from './routes/app/admin-settings/users/new/external-service-user'
import { Route as AppAdminSettingsGlobalSettingsDocusignConsentedRouteImport } from './routes/app/admin-settings/global-settings/docusign/consented'
import { Route as AppArtProductionsIdRoleIdIndexRouteImport } from './routes/app/art/productions/$id/$roleId/index'

const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VersionIndexRoute = VersionIndexRouteImport.update({
  id: '/version/',
  path: '/version/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticateWelcomeSetPasswordRoute =
  AuthenticateWelcomeSetPasswordRouteImport.update({
    id: '/authenticate/welcome-set-password',
    path: '/authenticate/welcome-set-password',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticateResetPasswordRoute =
  AuthenticateResetPasswordRouteImport.update({
    id: '/authenticate/reset-password',
    path: '/authenticate/reset-password',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatePasswordForgottenRoute =
  AuthenticatePasswordForgottenRouteImport.update({
    id: '/authenticate/password-forgotten',
    path: '/authenticate/password-forgotten',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticateLoginRoute = AuthenticateLoginRouteImport.update({
  id: '/authenticate/login',
  path: '/authenticate/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppResourcesRoute = AppResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => AppRoute,
} as any)
const AppPersonalDutyRosterRoute = AppPersonalDutyRosterRouteImport.update({
  id: '/personal-duty-roster',
  path: '/personal-duty-roster',
  getParentRoute: () => AppRoute,
} as any)
const AppOutboxRoute = AppOutboxRouteImport.update({
  id: '/outbox',
  path: '/outbox',
  getParentRoute: () => AppRoute,
} as any)
const AppOrchestraRoute = AppOrchestraRouteImport.update({
  id: '/orchestra',
  path: '/orchestra',
  getParentRoute: () => AppRoute,
} as any)
const AppDutySchedulingRoute = AppDutySchedulingRouteImport.update({
  id: '/duty-scheduling',
  path: '/duty-scheduling',
  getParentRoute: () => AppRoute,
} as any)
const AppDutyRosterRoute = AppDutyRosterRouteImport.update({
  id: '/duty-roster',
  path: '/duty-roster',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppContactsRoute = AppContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => AppRoute,
} as any)
const AppBackgroundJobsRoute = AppBackgroundJobsRouteImport.update({
  id: '/background-jobs',
  path: '/background-jobs',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminSettingsRoute = AppAdminSettingsRouteImport.update({
  id: '/admin-settings',
  path: '/admin-settings',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const ContractSigningContractIdIndexRoute =
  ContractSigningContractIdIndexRouteImport.update({
    id: '/contract-signing/$contractId/',
    path: '/contract-signing/$contractId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppResourcesIndexRoute = AppResourcesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppResourcesRoute,
} as any)
const AppOrchestraIndexRoute = AppOrchestraIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOrchestraRoute,
} as any)
const AppDutiesIndexRoute = AppDutiesIndexRouteImport.update({
  id: '/duties/',
  path: '/duties/',
  getParentRoute: () => AppRoute,
} as any)
const AppContactsIndexRoute = AppContactsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppContactsRoute,
} as any)
const AppAdminSettingsIndexRoute = AppAdminSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminSettingsRoute,
} as any)
const AppAccountIndexRoute = AppAccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAccountRoute,
} as any)
const ContractSigningContractIdSignedRoute =
  ContractSigningContractIdSignedRouteImport.update({
    id: '/contract-signing/$contractId/signed',
    path: '/contract-signing/$contractId/signed',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticateMfaSelectAuthenticationFactorRoute =
  AuthenticateMfaSelectAuthenticationFactorRouteImport.update({
    id: '/authenticate/mfa/select-authentication-factor',
    path: '/authenticate/mfa/select-authentication-factor',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticateMfaCreateRoute = AuthenticateMfaCreateRouteImport.update({
  id: '/authenticate/mfa/create',
  path: '/authenticate/mfa/create',
  getParentRoute: () => rootRouteImport,
} as any)
const AppResourcesResourcesRoute = AppResourcesResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => AppResourcesRoute,
} as any)
const AppResourcesResourceObjectsRoute =
  AppResourcesResourceObjectsRouteImport.update({
    id: '/resource-objects',
    path: '/resource-objects',
    getParentRoute: () => AppResourcesRoute,
  } as any)
const AppResourcesIdRoute = AppResourcesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppResourcesRoute,
} as any)
const AppMyRapportRoute = AppMyRapportRouteImport.update({
  id: '/my/rapport',
  path: '/my/rapport',
  getParentRoute: () => AppRoute,
} as any)
const AppMyCalendarSubscriptionsRoute =
  AppMyCalendarSubscriptionsRouteImport.update({
    id: '/my/calendar-subscriptions',
    path: '/my/calendar-subscriptions',
    getParentRoute: () => AppRoute,
  } as any)
const AppMyAbsencesRoute = AppMyAbsencesRouteImport.update({
  id: '/my/absences',
  path: '/my/absences',
  getParentRoute: () => AppRoute,
} as any)
const AppDutiesPrintRoute = AppDutiesPrintRouteImport.update({
  id: '/duties/print',
  path: '/duties/print',
  getParentRoute: () => AppRoute,
} as any)
const AppDutiesLeaveRequestsRoute = AppDutiesLeaveRequestsRouteImport.update({
  id: '/duties/leave-requests',
  path: '/duties/leave-requests',
  getParentRoute: () => AppRoute,
} as any)
const AppDutiesAbsencesRoute = AppDutiesAbsencesRouteImport.update({
  id: '/duties/absences',
  path: '/duties/absences',
  getParentRoute: () => AppRoute,
} as any)
const AppContractsContractsRoute = AppContractsContractsRouteImport.update({
  id: '/contracts/contracts',
  path: '/contracts/contracts',
  getParentRoute: () => AppRoute,
} as any)
const AppContractsApprovalsRoute = AppContractsApprovalsRouteImport.update({
  id: '/contracts/approvals',
  path: '/contracts/approvals',
  getParentRoute: () => AppRoute,
} as any)
const AppContactsIdRoute = AppContactsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppContactsRoute,
} as any)
const AppComChatRoute = AppComChatRouteImport.update({
  id: '/com/chat',
  path: '/com/chat',
  getParentRoute: () => AppRoute,
} as any)
const AppArtSchedulesRoute = AppArtSchedulesRouteImport.update({
  id: '/art/schedules',
  path: '/art/schedules',
  getParentRoute: () => AppRoute,
} as any)
const AppArtProductionsRoute = AppArtProductionsRouteImport.update({
  id: '/art/productions',
  path: '/art/productions',
  getParentRoute: () => AppRoute,
} as any)
const AppArtActivitiesRoute = AppArtActivitiesRouteImport.update({
  id: '/art/activities',
  path: '/art/activities',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminSettingsUsersRoute = AppAdminSettingsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppAdminSettingsRoute,
} as any)
const AppAdminSettingsOrganisationRoute =
  AppAdminSettingsOrganisationRouteImport.update({
    id: '/organisation',
    path: '/organisation',
    getParentRoute: () => AppAdminSettingsRoute,
  } as any)
const AppAdminSettingsInfoRoute = AppAdminSettingsInfoRouteImport.update({
  id: '/info',
  path: '/info',
  getParentRoute: () => AppAdminSettingsRoute,
} as any)
const AppAdminSettingsGlobalSettingsRoute =
  AppAdminSettingsGlobalSettingsRouteImport.update({
    id: '/global-settings',
    path: '/global-settings',
    getParentRoute: () => AppAdminSettingsRoute,
  } as any)
const AppAdminSettingsDashboardRoute =
  AppAdminSettingsDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AppAdminSettingsRoute,
  } as any)
const AppAdminSettingsAutomaticBackgroundJobsRoute =
  AppAdminSettingsAutomaticBackgroundJobsRouteImport.update({
    id: '/automatic-background-jobs',
    path: '/automatic-background-jobs',
    getParentRoute: () => AppAdminSettingsRoute,
  } as any)
const AppAdminSettingsAbsencesRoute =
  AppAdminSettingsAbsencesRouteImport.update({
    id: '/absences',
    path: '/absences',
    getParentRoute: () => AppAdminSettingsRoute,
  } as any)
const AppMyDutyRosterIndexRoute = AppMyDutyRosterIndexRouteImport.update({
  id: '/my/duty-roster/',
  path: '/my/duty-roster/',
  getParentRoute: () => AppRoute,
} as any)
const AppMyCalendarIndexRoute = AppMyCalendarIndexRouteImport.update({
  id: '/my/calendar/',
  path: '/my/calendar/',
  getParentRoute: () => AppRoute,
} as any)
const AppMyAbsencesIndexRoute = AppMyAbsencesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppMyAbsencesRoute,
} as any)
const AppDutiesShiftsAndCastsIndexRoute =
  AppDutiesShiftsAndCastsIndexRouteImport.update({
    id: '/duties/shifts-and-casts/',
    path: '/duties/shifts-and-casts/',
    getParentRoute: () => AppRoute,
  } as any)
const AppDutiesOrchestraIndexRoute = AppDutiesOrchestraIndexRouteImport.update({
  id: '/duties/orchestra/',
  path: '/duties/orchestra/',
  getParentRoute: () => AppRoute,
} as any)
const AppDutiesLeaveRequestsIndexRoute =
  AppDutiesLeaveRequestsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDutiesLeaveRequestsRoute,
  } as any)
const AppDutiesAbsencesIndexRoute = AppDutiesAbsencesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDutiesAbsencesRoute,
} as any)
const AppContractsContractsIndexRoute =
  AppContractsContractsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppContractsContractsRoute,
  } as any)
const AppContractsApprovalsIndexRoute =
  AppContractsApprovalsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppContractsApprovalsRoute,
  } as any)
const AppContactsCreateMemoIndexRoute =
  AppContactsCreateMemoIndexRouteImport.update({
    id: '/create-memo/',
    path: '/create-memo/',
    getParentRoute: () => AppContactsRoute,
  } as any)
const AppContactsCallIndexRoute = AppContactsCallIndexRouteImport.update({
  id: '/call/',
  path: '/call/',
  getParentRoute: () => AppContactsRoute,
} as any)
const AppContactsIdIndexRoute = AppContactsIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppContactsIdRoute,
} as any)
const AppComFeedsIndexRoute = AppComFeedsIndexRouteImport.update({
  id: '/com/feeds/',
  path: '/com/feeds/',
  getParentRoute: () => AppRoute,
} as any)
const AppComChatIndexRoute = AppComChatIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppComChatRoute,
} as any)
const AppArtProductionsIndexRoute = AppArtProductionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppArtProductionsRoute,
} as any)
const AppArtActivitiesIndexRoute = AppArtActivitiesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppArtActivitiesRoute,
} as any)
const AppAdminSettingsUsersIndexRoute =
  AppAdminSettingsUsersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminSettingsUsersRoute,
  } as any)
const AppAdminSettingsOrganisationIndexRoute =
  AppAdminSettingsOrganisationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminSettingsOrganisationRoute,
  } as any)
const AppAdminSettingsLoggingIndexRoute =
  AppAdminSettingsLoggingIndexRouteImport.update({
    id: '/logging/',
    path: '/logging/',
    getParentRoute: () => AppAdminSettingsRoute,
  } as any)
const AppAdminSettingsInfoIndexRoute =
  AppAdminSettingsInfoIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminSettingsInfoRoute,
  } as any)
const AppAdminSettingsGlobalSettingsIndexRoute =
  AppAdminSettingsGlobalSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminSettingsGlobalSettingsRoute,
  } as any)
const AppAdminSettingsAutomaticBackgroundJobsIndexRoute =
  AppAdminSettingsAutomaticBackgroundJobsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminSettingsAutomaticBackgroundJobsRoute,
  } as any)
const AppAdminSettingsAbsencesIndexRoute =
  AppAdminSettingsAbsencesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminSettingsAbsencesRoute,
  } as any)
const AuthenticateMfaIdValidateRoute =
  AuthenticateMfaIdValidateRouteImport.update({
    id: '/authenticate/mfa/$id/validate',
    path: '/authenticate/mfa/$id/validate',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticateMfaIdRegisterRoute =
  AuthenticateMfaIdRegisterRouteImport.update({
    id: '/authenticate/mfa/$id/register',
    path: '/authenticate/mfa/$id/register',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppMyAbsencesSuccessfullySendRoute =
  AppMyAbsencesSuccessfullySendRouteImport.update({
    id: '/successfully-send',
    path: '/successfully-send',
    getParentRoute: () => AppMyAbsencesRoute,
  } as any)
const AppMyAbsencesNewLeaveRequestRoute =
  AppMyAbsencesNewLeaveRequestRouteImport.update({
    id: '/new-leave-request',
    path: '/new-leave-request',
    getParentRoute: () => AppMyAbsencesRoute,
  } as any)
const AppMyAbsencesIdRoute = AppMyAbsencesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppMyAbsencesRoute,
} as any)
const AppDutiesLeaveRequestsEventLogRoute =
  AppDutiesLeaveRequestsEventLogRouteImport.update({
    id: '/event-log',
    path: '/event-log',
    getParentRoute: () => AppDutiesLeaveRequestsRoute,
  } as any)
const AppDutiesLeaveRequestsIdRoute =
  AppDutiesLeaveRequestsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AppDutiesLeaveRequestsRoute,
  } as any)
const AppContractsContractsIdRoute = AppContractsContractsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppContractsContractsRoute,
} as any)
const AppComChatChatIdRoute = AppComChatChatIdRouteImport.update({
  id: '/$chatId',
  path: '/$chatId',
  getParentRoute: () => AppComChatRoute,
} as any)
const AppArtProductionsIdRoute = AppArtProductionsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppArtProductionsRoute,
} as any)
const AppArtActivitiesIdRoute = AppArtActivitiesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppArtActivitiesRoute,
} as any)
const AppAdminSettingsUsersNewRoute =
  AppAdminSettingsUsersNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppAdminSettingsUsersRoute,
  } as any)
const AppAdminSettingsUsersIdRoute = AppAdminSettingsUsersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppAdminSettingsUsersRoute,
} as any)
const AppAdminSettingsLoggingIdRoute =
  AppAdminSettingsLoggingIdRouteImport.update({
    id: '/logging/$id',
    path: '/logging/$id',
    getParentRoute: () => AppAdminSettingsRoute,
  } as any)
const AppAdminSettingsAutomaticBackgroundJobsTableRoute =
  AppAdminSettingsAutomaticBackgroundJobsTableRouteImport.update({
    id: '/table',
    path: '/table',
    getParentRoute: () => AppAdminSettingsAutomaticBackgroundJobsRoute,
  } as any)
const AppAdminSettingsAutomaticBackgroundJobsNewRoute =
  AppAdminSettingsAutomaticBackgroundJobsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppAdminSettingsAutomaticBackgroundJobsRoute,
  } as any)
const AppAdminSettingsAutomaticBackgroundJobsIdRoute =
  AppAdminSettingsAutomaticBackgroundJobsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AppAdminSettingsAutomaticBackgroundJobsRoute,
  } as any)
const AppAdminSettingsAbsencesNewRoute =
  AppAdminSettingsAbsencesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppAdminSettingsAbsencesRoute,
  } as any)
const AppAdminSettingsAbsencesIdRoute =
  AppAdminSettingsAbsencesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AppAdminSettingsAbsencesRoute,
  } as any)
const AppContractsApprovalsContractIdIndexRoute =
  AppContractsApprovalsContractIdIndexRouteImport.update({
    id: '/$contractId/',
    path: '/$contractId/',
    getParentRoute: () => AppContractsApprovalsRoute,
  } as any)
const AppComFeedsFeedIdIndexRoute = AppComFeedsFeedIdIndexRouteImport.update({
  id: '/com/feeds/$feedId/',
  path: '/com/feeds/$feedId/',
  getParentRoute: () => AppRoute,
} as any)
const AppArtProductionsIdIndexRoute =
  AppArtProductionsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppArtProductionsIdRoute,
  } as any)
const AppAdminSettingsUsersNewIndexRoute =
  AppAdminSettingsUsersNewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminSettingsUsersNewRoute,
  } as any)
const AppDutiesLeaveRequestsDebugViewIdRoute =
  AppDutiesLeaveRequestsDebugViewIdRouteImport.update({
    id: '/debug-view/$id',
    path: '/debug-view/$id',
    getParentRoute: () => AppDutiesLeaveRequestsRoute,
  } as any)
const AppContractsApprovalsContractIdSignedRoute =
  AppContractsApprovalsContractIdSignedRouteImport.update({
    id: '/$contractId/signed',
    path: '/$contractId/signed',
    getParentRoute: () => AppContractsApprovalsRoute,
  } as any)
const AppComFeedsFeedIdPostIdRoute = AppComFeedsFeedIdPostIdRouteImport.update({
  id: '/com/feeds/$feedId/$postId',
  path: '/com/feeds/$feedId/$postId',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminSettingsUsersNewUsersForPersonsRoute =
  AppAdminSettingsUsersNewUsersForPersonsRouteImport.update({
    id: '/users-for-persons',
    path: '/users-for-persons',
    getParentRoute: () => AppAdminSettingsUsersNewRoute,
  } as any)
const AppAdminSettingsUsersNewUserForPersonRoute =
  AppAdminSettingsUsersNewUserForPersonRouteImport.update({
    id: '/user-for-person',
    path: '/user-for-person',
    getParentRoute: () => AppAdminSettingsUsersNewRoute,
  } as any)
const AppAdminSettingsUsersNewExternalServiceUserRoute =
  AppAdminSettingsUsersNewExternalServiceUserRouteImport.update({
    id: '/external-service-user',
    path: '/external-service-user',
    getParentRoute: () => AppAdminSettingsUsersNewRoute,
  } as any)
const AppAdminSettingsGlobalSettingsDocusignConsentedRoute =
  AppAdminSettingsGlobalSettingsDocusignConsentedRouteImport.update({
    id: '/docusign/consented',
    path: '/docusign/consented',
    getParentRoute: () => AppAdminSettingsGlobalSettingsRoute,
  } as any)
const AppArtProductionsIdRoleIdIndexRoute =
  AppArtProductionsIdRoleIdIndexRouteImport.update({
    id: '/$roleId/',
    path: '/$roleId/',
    getParentRoute: () => AppArtProductionsIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/app/account': typeof AppAccountRouteWithChildren
  '/app/admin-settings': typeof AppAdminSettingsRouteWithChildren
  '/app/background-jobs': typeof AppBackgroundJobsRoute
  '/app/contacts': typeof AppContactsRouteWithChildren
  '/app/dashboard': typeof AppDashboardRoute
  '/app/duty-roster': typeof AppDutyRosterRoute
  '/app/duty-scheduling': typeof AppDutySchedulingRoute
  '/app/orchestra': typeof AppOrchestraRouteWithChildren
  '/app/outbox': typeof AppOutboxRoute
  '/app/personal-duty-roster': typeof AppPersonalDutyRosterRoute
  '/app/resources': typeof AppResourcesRouteWithChildren
  '/authenticate/login': typeof AuthenticateLoginRoute
  '/authenticate/password-forgotten': typeof AuthenticatePasswordForgottenRoute
  '/authenticate/reset-password': typeof AuthenticateResetPasswordRoute
  '/authenticate/welcome-set-password': typeof AuthenticateWelcomeSetPasswordRoute
  '/version': typeof VersionIndexRoute
  '/app/admin-settings/absences': typeof AppAdminSettingsAbsencesRouteWithChildren
  '/app/admin-settings/automatic-background-jobs': typeof AppAdminSettingsAutomaticBackgroundJobsRouteWithChildren
  '/app/admin-settings/dashboard': typeof AppAdminSettingsDashboardRoute
  '/app/admin-settings/global-settings': typeof AppAdminSettingsGlobalSettingsRouteWithChildren
  '/app/admin-settings/info': typeof AppAdminSettingsInfoRouteWithChildren
  '/app/admin-settings/organisation': typeof AppAdminSettingsOrganisationRouteWithChildren
  '/app/admin-settings/users': typeof AppAdminSettingsUsersRouteWithChildren
  '/app/art/activities': typeof AppArtActivitiesRouteWithChildren
  '/app/art/productions': typeof AppArtProductionsRouteWithChildren
  '/app/art/schedules': typeof AppArtSchedulesRoute
  '/app/com/chat': typeof AppComChatRouteWithChildren
  '/app/contacts/$id': typeof AppContactsIdRouteWithChildren
  '/app/contracts/approvals': typeof AppContractsApprovalsRouteWithChildren
  '/app/contracts/contracts': typeof AppContractsContractsRouteWithChildren
  '/app/duties/absences': typeof AppDutiesAbsencesRouteWithChildren
  '/app/duties/leave-requests': typeof AppDutiesLeaveRequestsRouteWithChildren
  '/app/duties/print': typeof AppDutiesPrintRoute
  '/app/my/absences': typeof AppMyAbsencesRouteWithChildren
  '/app/my/calendar-subscriptions': typeof AppMyCalendarSubscriptionsRoute
  '/app/my/rapport': typeof AppMyRapportRoute
  '/app/resources/$id': typeof AppResourcesIdRoute
  '/app/resources/resource-objects': typeof AppResourcesResourceObjectsRoute
  '/app/resources/resources': typeof AppResourcesResourcesRoute
  '/authenticate/mfa/create': typeof AuthenticateMfaCreateRoute
  '/authenticate/mfa/select-authentication-factor': typeof AuthenticateMfaSelectAuthenticationFactorRoute
  '/contract-signing/$contractId/signed': typeof ContractSigningContractIdSignedRoute
  '/app/account/': typeof AppAccountIndexRoute
  '/app/admin-settings/': typeof AppAdminSettingsIndexRoute
  '/app/contacts/': typeof AppContactsIndexRoute
  '/app/duties': typeof AppDutiesIndexRoute
  '/app/orchestra/': typeof AppOrchestraIndexRoute
  '/app/resources/': typeof AppResourcesIndexRoute
  '/contract-signing/$contractId': typeof ContractSigningContractIdIndexRoute
  '/app/admin-settings/absences/$id': typeof AppAdminSettingsAbsencesIdRoute
  '/app/admin-settings/absences/new': typeof AppAdminSettingsAbsencesNewRoute
  '/app/admin-settings/automatic-background-jobs/$id': typeof AppAdminSettingsAutomaticBackgroundJobsIdRoute
  '/app/admin-settings/automatic-background-jobs/new': typeof AppAdminSettingsAutomaticBackgroundJobsNewRoute
  '/app/admin-settings/automatic-background-jobs/table': typeof AppAdminSettingsAutomaticBackgroundJobsTableRoute
  '/app/admin-settings/logging/$id': typeof AppAdminSettingsLoggingIdRoute
  '/app/admin-settings/users/$id': typeof AppAdminSettingsUsersIdRoute
  '/app/admin-settings/users/new': typeof AppAdminSettingsUsersNewRouteWithChildren
  '/app/art/activities/$id': typeof AppArtActivitiesIdRoute
  '/app/art/productions/$id': typeof AppArtProductionsIdRouteWithChildren
  '/app/com/chat/$chatId': typeof AppComChatChatIdRoute
  '/app/contracts/contracts/$id': typeof AppContractsContractsIdRoute
  '/app/duties/leave-requests/$id': typeof AppDutiesLeaveRequestsIdRoute
  '/app/duties/leave-requests/event-log': typeof AppDutiesLeaveRequestsEventLogRoute
  '/app/my/absences/$id': typeof AppMyAbsencesIdRoute
  '/app/my/absences/new-leave-request': typeof AppMyAbsencesNewLeaveRequestRoute
  '/app/my/absences/successfully-send': typeof AppMyAbsencesSuccessfullySendRoute
  '/authenticate/mfa/$id/register': typeof AuthenticateMfaIdRegisterRoute
  '/authenticate/mfa/$id/validate': typeof AuthenticateMfaIdValidateRoute
  '/app/admin-settings/absences/': typeof AppAdminSettingsAbsencesIndexRoute
  '/app/admin-settings/automatic-background-jobs/': typeof AppAdminSettingsAutomaticBackgroundJobsIndexRoute
  '/app/admin-settings/global-settings/': typeof AppAdminSettingsGlobalSettingsIndexRoute
  '/app/admin-settings/info/': typeof AppAdminSettingsInfoIndexRoute
  '/app/admin-settings/logging': typeof AppAdminSettingsLoggingIndexRoute
  '/app/admin-settings/organisation/': typeof AppAdminSettingsOrganisationIndexRoute
  '/app/admin-settings/users/': typeof AppAdminSettingsUsersIndexRoute
  '/app/art/activities/': typeof AppArtActivitiesIndexRoute
  '/app/art/productions/': typeof AppArtProductionsIndexRoute
  '/app/com/chat/': typeof AppComChatIndexRoute
  '/app/com/feeds': typeof AppComFeedsIndexRoute
  '/app/contacts/$id/': typeof AppContactsIdIndexRoute
  '/app/contacts/call': typeof AppContactsCallIndexRoute
  '/app/contacts/create-memo': typeof AppContactsCreateMemoIndexRoute
  '/app/contracts/approvals/': typeof AppContractsApprovalsIndexRoute
  '/app/contracts/contracts/': typeof AppContractsContractsIndexRoute
  '/app/duties/absences/': typeof AppDutiesAbsencesIndexRoute
  '/app/duties/leave-requests/': typeof AppDutiesLeaveRequestsIndexRoute
  '/app/duties/orchestra': typeof AppDutiesOrchestraIndexRoute
  '/app/duties/shifts-and-casts': typeof AppDutiesShiftsAndCastsIndexRoute
  '/app/my/absences/': typeof AppMyAbsencesIndexRoute
  '/app/my/calendar': typeof AppMyCalendarIndexRoute
  '/app/my/duty-roster': typeof AppMyDutyRosterIndexRoute
  '/app/admin-settings/global-settings/docusign/consented': typeof AppAdminSettingsGlobalSettingsDocusignConsentedRoute
  '/app/admin-settings/users/new/external-service-user': typeof AppAdminSettingsUsersNewExternalServiceUserRoute
  '/app/admin-settings/users/new/user-for-person': typeof AppAdminSettingsUsersNewUserForPersonRoute
  '/app/admin-settings/users/new/users-for-persons': typeof AppAdminSettingsUsersNewUsersForPersonsRoute
  '/app/com/feeds/$feedId/$postId': typeof AppComFeedsFeedIdPostIdRoute
  '/app/contracts/approvals/$contractId/signed': typeof AppContractsApprovalsContractIdSignedRoute
  '/app/duties/leave-requests/debug-view/$id': typeof AppDutiesLeaveRequestsDebugViewIdRoute
  '/app/admin-settings/users/new/': typeof AppAdminSettingsUsersNewIndexRoute
  '/app/art/productions/$id/': typeof AppArtProductionsIdIndexRoute
  '/app/com/feeds/$feedId': typeof AppComFeedsFeedIdIndexRoute
  '/app/contracts/approvals/$contractId': typeof AppContractsApprovalsContractIdIndexRoute
  '/app/art/productions/$id/$roleId': typeof AppArtProductionsIdRoleIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/app/background-jobs': typeof AppBackgroundJobsRoute
  '/app/dashboard': typeof AppDashboardRoute
  '/app/duty-roster': typeof AppDutyRosterRoute
  '/app/duty-scheduling': typeof AppDutySchedulingRoute
  '/app/outbox': typeof AppOutboxRoute
  '/app/personal-duty-roster': typeof AppPersonalDutyRosterRoute
  '/authenticate/login': typeof AuthenticateLoginRoute
  '/authenticate/password-forgotten': typeof AuthenticatePasswordForgottenRoute
  '/authenticate/reset-password': typeof AuthenticateResetPasswordRoute
  '/authenticate/welcome-set-password': typeof AuthenticateWelcomeSetPasswordRoute
  '/version': typeof VersionIndexRoute
  '/app/admin-settings/dashboard': typeof AppAdminSettingsDashboardRoute
  '/app/art/schedules': typeof AppArtSchedulesRoute
  '/app/duties/print': typeof AppDutiesPrintRoute
  '/app/my/calendar-subscriptions': typeof AppMyCalendarSubscriptionsRoute
  '/app/my/rapport': typeof AppMyRapportRoute
  '/app/resources/$id': typeof AppResourcesIdRoute
  '/app/resources/resource-objects': typeof AppResourcesResourceObjectsRoute
  '/app/resources/resources': typeof AppResourcesResourcesRoute
  '/authenticate/mfa/create': typeof AuthenticateMfaCreateRoute
  '/authenticate/mfa/select-authentication-factor': typeof AuthenticateMfaSelectAuthenticationFactorRoute
  '/contract-signing/$contractId/signed': typeof ContractSigningContractIdSignedRoute
  '/app/account': typeof AppAccountIndexRoute
  '/app/admin-settings': typeof AppAdminSettingsIndexRoute
  '/app/contacts': typeof AppContactsIndexRoute
  '/app/duties': typeof AppDutiesIndexRoute
  '/app/orchestra': typeof AppOrchestraIndexRoute
  '/app/resources': typeof AppResourcesIndexRoute
  '/contract-signing/$contractId': typeof ContractSigningContractIdIndexRoute
  '/app/admin-settings/absences/$id': typeof AppAdminSettingsAbsencesIdRoute
  '/app/admin-settings/absences/new': typeof AppAdminSettingsAbsencesNewRoute
  '/app/admin-settings/automatic-background-jobs/$id': typeof AppAdminSettingsAutomaticBackgroundJobsIdRoute
  '/app/admin-settings/automatic-background-jobs/new': typeof AppAdminSettingsAutomaticBackgroundJobsNewRoute
  '/app/admin-settings/automatic-background-jobs/table': typeof AppAdminSettingsAutomaticBackgroundJobsTableRoute
  '/app/admin-settings/logging/$id': typeof AppAdminSettingsLoggingIdRoute
  '/app/admin-settings/users/$id': typeof AppAdminSettingsUsersIdRoute
  '/app/art/activities/$id': typeof AppArtActivitiesIdRoute
  '/app/com/chat/$chatId': typeof AppComChatChatIdRoute
  '/app/contracts/contracts/$id': typeof AppContractsContractsIdRoute
  '/app/duties/leave-requests/$id': typeof AppDutiesLeaveRequestsIdRoute
  '/app/duties/leave-requests/event-log': typeof AppDutiesLeaveRequestsEventLogRoute
  '/app/my/absences/$id': typeof AppMyAbsencesIdRoute
  '/app/my/absences/new-leave-request': typeof AppMyAbsencesNewLeaveRequestRoute
  '/app/my/absences/successfully-send': typeof AppMyAbsencesSuccessfullySendRoute
  '/authenticate/mfa/$id/register': typeof AuthenticateMfaIdRegisterRoute
  '/authenticate/mfa/$id/validate': typeof AuthenticateMfaIdValidateRoute
  '/app/admin-settings/absences': typeof AppAdminSettingsAbsencesIndexRoute
  '/app/admin-settings/automatic-background-jobs': typeof AppAdminSettingsAutomaticBackgroundJobsIndexRoute
  '/app/admin-settings/global-settings': typeof AppAdminSettingsGlobalSettingsIndexRoute
  '/app/admin-settings/info': typeof AppAdminSettingsInfoIndexRoute
  '/app/admin-settings/logging': typeof AppAdminSettingsLoggingIndexRoute
  '/app/admin-settings/organisation': typeof AppAdminSettingsOrganisationIndexRoute
  '/app/admin-settings/users': typeof AppAdminSettingsUsersIndexRoute
  '/app/art/activities': typeof AppArtActivitiesIndexRoute
  '/app/art/productions': typeof AppArtProductionsIndexRoute
  '/app/com/chat': typeof AppComChatIndexRoute
  '/app/com/feeds': typeof AppComFeedsIndexRoute
  '/app/contacts/$id': typeof AppContactsIdIndexRoute
  '/app/contacts/call': typeof AppContactsCallIndexRoute
  '/app/contacts/create-memo': typeof AppContactsCreateMemoIndexRoute
  '/app/contracts/approvals': typeof AppContractsApprovalsIndexRoute
  '/app/contracts/contracts': typeof AppContractsContractsIndexRoute
  '/app/duties/absences': typeof AppDutiesAbsencesIndexRoute
  '/app/duties/leave-requests': typeof AppDutiesLeaveRequestsIndexRoute
  '/app/duties/orchestra': typeof AppDutiesOrchestraIndexRoute
  '/app/duties/shifts-and-casts': typeof AppDutiesShiftsAndCastsIndexRoute
  '/app/my/absences': typeof AppMyAbsencesIndexRoute
  '/app/my/calendar': typeof AppMyCalendarIndexRoute
  '/app/my/duty-roster': typeof AppMyDutyRosterIndexRoute
  '/app/admin-settings/global-settings/docusign/consented': typeof AppAdminSettingsGlobalSettingsDocusignConsentedRoute
  '/app/admin-settings/users/new/external-service-user': typeof AppAdminSettingsUsersNewExternalServiceUserRoute
  '/app/admin-settings/users/new/user-for-person': typeof AppAdminSettingsUsersNewUserForPersonRoute
  '/app/admin-settings/users/new/users-for-persons': typeof AppAdminSettingsUsersNewUsersForPersonsRoute
  '/app/com/feeds/$feedId/$postId': typeof AppComFeedsFeedIdPostIdRoute
  '/app/contracts/approvals/$contractId/signed': typeof AppContractsApprovalsContractIdSignedRoute
  '/app/duties/leave-requests/debug-view/$id': typeof AppDutiesLeaveRequestsDebugViewIdRoute
  '/app/admin-settings/users/new': typeof AppAdminSettingsUsersNewIndexRoute
  '/app/art/productions/$id': typeof AppArtProductionsIdIndexRoute
  '/app/com/feeds/$feedId': typeof AppComFeedsFeedIdIndexRoute
  '/app/contracts/approvals/$contractId': typeof AppContractsApprovalsContractIdIndexRoute
  '/app/art/productions/$id/$roleId': typeof AppArtProductionsIdRoleIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/app/account': typeof AppAccountRouteWithChildren
  '/app/admin-settings': typeof AppAdminSettingsRouteWithChildren
  '/app/background-jobs': typeof AppBackgroundJobsRoute
  '/app/contacts': typeof AppContactsRouteWithChildren
  '/app/dashboard': typeof AppDashboardRoute
  '/app/duty-roster': typeof AppDutyRosterRoute
  '/app/duty-scheduling': typeof AppDutySchedulingRoute
  '/app/orchestra': typeof AppOrchestraRouteWithChildren
  '/app/outbox': typeof AppOutboxRoute
  '/app/personal-duty-roster': typeof AppPersonalDutyRosterRoute
  '/app/resources': typeof AppResourcesRouteWithChildren
  '/authenticate/login': typeof AuthenticateLoginRoute
  '/authenticate/password-forgotten': typeof AuthenticatePasswordForgottenRoute
  '/authenticate/reset-password': typeof AuthenticateResetPasswordRoute
  '/authenticate/welcome-set-password': typeof AuthenticateWelcomeSetPasswordRoute
  '/version/': typeof VersionIndexRoute
  '/app/admin-settings/absences': typeof AppAdminSettingsAbsencesRouteWithChildren
  '/app/admin-settings/automatic-background-jobs': typeof AppAdminSettingsAutomaticBackgroundJobsRouteWithChildren
  '/app/admin-settings/dashboard': typeof AppAdminSettingsDashboardRoute
  '/app/admin-settings/global-settings': typeof AppAdminSettingsGlobalSettingsRouteWithChildren
  '/app/admin-settings/info': typeof AppAdminSettingsInfoRouteWithChildren
  '/app/admin-settings/organisation': typeof AppAdminSettingsOrganisationRouteWithChildren
  '/app/admin-settings/users': typeof AppAdminSettingsUsersRouteWithChildren
  '/app/art/activities': typeof AppArtActivitiesRouteWithChildren
  '/app/art/productions': typeof AppArtProductionsRouteWithChildren
  '/app/art/schedules': typeof AppArtSchedulesRoute
  '/app/com/chat': typeof AppComChatRouteWithChildren
  '/app/contacts/$id': typeof AppContactsIdRouteWithChildren
  '/app/contracts/approvals': typeof AppContractsApprovalsRouteWithChildren
  '/app/contracts/contracts': typeof AppContractsContractsRouteWithChildren
  '/app/duties/absences': typeof AppDutiesAbsencesRouteWithChildren
  '/app/duties/leave-requests': typeof AppDutiesLeaveRequestsRouteWithChildren
  '/app/duties/print': typeof AppDutiesPrintRoute
  '/app/my/absences': typeof AppMyAbsencesRouteWithChildren
  '/app/my/calendar-subscriptions': typeof AppMyCalendarSubscriptionsRoute
  '/app/my/rapport': typeof AppMyRapportRoute
  '/app/resources/$id': typeof AppResourcesIdRoute
  '/app/resources/resource-objects': typeof AppResourcesResourceObjectsRoute
  '/app/resources/resources': typeof AppResourcesResourcesRoute
  '/authenticate/mfa/create': typeof AuthenticateMfaCreateRoute
  '/authenticate/mfa/select-authentication-factor': typeof AuthenticateMfaSelectAuthenticationFactorRoute
  '/contract-signing/$contractId/signed': typeof ContractSigningContractIdSignedRoute
  '/app/account/': typeof AppAccountIndexRoute
  '/app/admin-settings/': typeof AppAdminSettingsIndexRoute
  '/app/contacts/': typeof AppContactsIndexRoute
  '/app/duties/': typeof AppDutiesIndexRoute
  '/app/orchestra/': typeof AppOrchestraIndexRoute
  '/app/resources/': typeof AppResourcesIndexRoute
  '/contract-signing/$contractId/': typeof ContractSigningContractIdIndexRoute
  '/app/admin-settings/absences/$id': typeof AppAdminSettingsAbsencesIdRoute
  '/app/admin-settings/absences/new': typeof AppAdminSettingsAbsencesNewRoute
  '/app/admin-settings/automatic-background-jobs/$id': typeof AppAdminSettingsAutomaticBackgroundJobsIdRoute
  '/app/admin-settings/automatic-background-jobs/new': typeof AppAdminSettingsAutomaticBackgroundJobsNewRoute
  '/app/admin-settings/automatic-background-jobs/table': typeof AppAdminSettingsAutomaticBackgroundJobsTableRoute
  '/app/admin-settings/logging/$id': typeof AppAdminSettingsLoggingIdRoute
  '/app/admin-settings/users/$id': typeof AppAdminSettingsUsersIdRoute
  '/app/admin-settings/users/new': typeof AppAdminSettingsUsersNewRouteWithChildren
  '/app/art/activities/$id': typeof AppArtActivitiesIdRoute
  '/app/art/productions/$id': typeof AppArtProductionsIdRouteWithChildren
  '/app/com/chat/$chatId': typeof AppComChatChatIdRoute
  '/app/contracts/contracts/$id': typeof AppContractsContractsIdRoute
  '/app/duties/leave-requests/$id': typeof AppDutiesLeaveRequestsIdRoute
  '/app/duties/leave-requests/event-log': typeof AppDutiesLeaveRequestsEventLogRoute
  '/app/my/absences/$id': typeof AppMyAbsencesIdRoute
  '/app/my/absences/new-leave-request': typeof AppMyAbsencesNewLeaveRequestRoute
  '/app/my/absences/successfully-send': typeof AppMyAbsencesSuccessfullySendRoute
  '/authenticate/mfa/$id/register': typeof AuthenticateMfaIdRegisterRoute
  '/authenticate/mfa/$id/validate': typeof AuthenticateMfaIdValidateRoute
  '/app/admin-settings/absences/': typeof AppAdminSettingsAbsencesIndexRoute
  '/app/admin-settings/automatic-background-jobs/': typeof AppAdminSettingsAutomaticBackgroundJobsIndexRoute
  '/app/admin-settings/global-settings/': typeof AppAdminSettingsGlobalSettingsIndexRoute
  '/app/admin-settings/info/': typeof AppAdminSettingsInfoIndexRoute
  '/app/admin-settings/logging/': typeof AppAdminSettingsLoggingIndexRoute
  '/app/admin-settings/organisation/': typeof AppAdminSettingsOrganisationIndexRoute
  '/app/admin-settings/users/': typeof AppAdminSettingsUsersIndexRoute
  '/app/art/activities/': typeof AppArtActivitiesIndexRoute
  '/app/art/productions/': typeof AppArtProductionsIndexRoute
  '/app/com/chat/': typeof AppComChatIndexRoute
  '/app/com/feeds/': typeof AppComFeedsIndexRoute
  '/app/contacts/$id/': typeof AppContactsIdIndexRoute
  '/app/contacts/call/': typeof AppContactsCallIndexRoute
  '/app/contacts/create-memo/': typeof AppContactsCreateMemoIndexRoute
  '/app/contracts/approvals/': typeof AppContractsApprovalsIndexRoute
  '/app/contracts/contracts/': typeof AppContractsContractsIndexRoute
  '/app/duties/absences/': typeof AppDutiesAbsencesIndexRoute
  '/app/duties/leave-requests/': typeof AppDutiesLeaveRequestsIndexRoute
  '/app/duties/orchestra/': typeof AppDutiesOrchestraIndexRoute
  '/app/duties/shifts-and-casts/': typeof AppDutiesShiftsAndCastsIndexRoute
  '/app/my/absences/': typeof AppMyAbsencesIndexRoute
  '/app/my/calendar/': typeof AppMyCalendarIndexRoute
  '/app/my/duty-roster/': typeof AppMyDutyRosterIndexRoute
  '/app/admin-settings/global-settings/docusign/consented': typeof AppAdminSettingsGlobalSettingsDocusignConsentedRoute
  '/app/admin-settings/users/new/external-service-user': typeof AppAdminSettingsUsersNewExternalServiceUserRoute
  '/app/admin-settings/users/new/user-for-person': typeof AppAdminSettingsUsersNewUserForPersonRoute
  '/app/admin-settings/users/new/users-for-persons': typeof AppAdminSettingsUsersNewUsersForPersonsRoute
  '/app/com/feeds/$feedId/$postId': typeof AppComFeedsFeedIdPostIdRoute
  '/app/contracts/approvals/$contractId/signed': typeof AppContractsApprovalsContractIdSignedRoute
  '/app/duties/leave-requests/debug-view/$id': typeof AppDutiesLeaveRequestsDebugViewIdRoute
  '/app/admin-settings/users/new/': typeof AppAdminSettingsUsersNewIndexRoute
  '/app/art/productions/$id/': typeof AppArtProductionsIdIndexRoute
  '/app/com/feeds/$feedId/': typeof AppComFeedsFeedIdIndexRoute
  '/app/contracts/approvals/$contractId/': typeof AppContractsApprovalsContractIdIndexRoute
  '/app/art/productions/$id/$roleId/': typeof AppArtProductionsIdRoleIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/app/account'
    | '/app/admin-settings'
    | '/app/background-jobs'
    | '/app/contacts'
    | '/app/dashboard'
    | '/app/duty-roster'
    | '/app/duty-scheduling'
    | '/app/orchestra'
    | '/app/outbox'
    | '/app/personal-duty-roster'
    | '/app/resources'
    | '/authenticate/login'
    | '/authenticate/password-forgotten'
    | '/authenticate/reset-password'
    | '/authenticate/welcome-set-password'
    | '/version'
    | '/app/admin-settings/absences'
    | '/app/admin-settings/automatic-background-jobs'
    | '/app/admin-settings/dashboard'
    | '/app/admin-settings/global-settings'
    | '/app/admin-settings/info'
    | '/app/admin-settings/organisation'
    | '/app/admin-settings/users'
    | '/app/art/activities'
    | '/app/art/productions'
    | '/app/art/schedules'
    | '/app/com/chat'
    | '/app/contacts/$id'
    | '/app/contracts/approvals'
    | '/app/contracts/contracts'
    | '/app/duties/absences'
    | '/app/duties/leave-requests'
    | '/app/duties/print'
    | '/app/my/absences'
    | '/app/my/calendar-subscriptions'
    | '/app/my/rapport'
    | '/app/resources/$id'
    | '/app/resources/resource-objects'
    | '/app/resources/resources'
    | '/authenticate/mfa/create'
    | '/authenticate/mfa/select-authentication-factor'
    | '/contract-signing/$contractId/signed'
    | '/app/account/'
    | '/app/admin-settings/'
    | '/app/contacts/'
    | '/app/duties'
    | '/app/orchestra/'
    | '/app/resources/'
    | '/contract-signing/$contractId'
    | '/app/admin-settings/absences/$id'
    | '/app/admin-settings/absences/new'
    | '/app/admin-settings/automatic-background-jobs/$id'
    | '/app/admin-settings/automatic-background-jobs/new'
    | '/app/admin-settings/automatic-background-jobs/table'
    | '/app/admin-settings/logging/$id'
    | '/app/admin-settings/users/$id'
    | '/app/admin-settings/users/new'
    | '/app/art/activities/$id'
    | '/app/art/productions/$id'
    | '/app/com/chat/$chatId'
    | '/app/contracts/contracts/$id'
    | '/app/duties/leave-requests/$id'
    | '/app/duties/leave-requests/event-log'
    | '/app/my/absences/$id'
    | '/app/my/absences/new-leave-request'
    | '/app/my/absences/successfully-send'
    | '/authenticate/mfa/$id/register'
    | '/authenticate/mfa/$id/validate'
    | '/app/admin-settings/absences/'
    | '/app/admin-settings/automatic-background-jobs/'
    | '/app/admin-settings/global-settings/'
    | '/app/admin-settings/info/'
    | '/app/admin-settings/logging'
    | '/app/admin-settings/organisation/'
    | '/app/admin-settings/users/'
    | '/app/art/activities/'
    | '/app/art/productions/'
    | '/app/com/chat/'
    | '/app/com/feeds'
    | '/app/contacts/$id/'
    | '/app/contacts/call'
    | '/app/contacts/create-memo'
    | '/app/contracts/approvals/'
    | '/app/contracts/contracts/'
    | '/app/duties/absences/'
    | '/app/duties/leave-requests/'
    | '/app/duties/orchestra'
    | '/app/duties/shifts-and-casts'
    | '/app/my/absences/'
    | '/app/my/calendar'
    | '/app/my/duty-roster'
    | '/app/admin-settings/global-settings/docusign/consented'
    | '/app/admin-settings/users/new/external-service-user'
    | '/app/admin-settings/users/new/user-for-person'
    | '/app/admin-settings/users/new/users-for-persons'
    | '/app/com/feeds/$feedId/$postId'
    | '/app/contracts/approvals/$contractId/signed'
    | '/app/duties/leave-requests/debug-view/$id'
    | '/app/admin-settings/users/new/'
    | '/app/art/productions/$id/'
    | '/app/com/feeds/$feedId'
    | '/app/contracts/approvals/$contractId'
    | '/app/art/productions/$id/$roleId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app'
    | '/app/background-jobs'
    | '/app/dashboard'
    | '/app/duty-roster'
    | '/app/duty-scheduling'
    | '/app/outbox'
    | '/app/personal-duty-roster'
    | '/authenticate/login'
    | '/authenticate/password-forgotten'
    | '/authenticate/reset-password'
    | '/authenticate/welcome-set-password'
    | '/version'
    | '/app/admin-settings/dashboard'
    | '/app/art/schedules'
    | '/app/duties/print'
    | '/app/my/calendar-subscriptions'
    | '/app/my/rapport'
    | '/app/resources/$id'
    | '/app/resources/resource-objects'
    | '/app/resources/resources'
    | '/authenticate/mfa/create'
    | '/authenticate/mfa/select-authentication-factor'
    | '/contract-signing/$contractId/signed'
    | '/app/account'
    | '/app/admin-settings'
    | '/app/contacts'
    | '/app/duties'
    | '/app/orchestra'
    | '/app/resources'
    | '/contract-signing/$contractId'
    | '/app/admin-settings/absences/$id'
    | '/app/admin-settings/absences/new'
    | '/app/admin-settings/automatic-background-jobs/$id'
    | '/app/admin-settings/automatic-background-jobs/new'
    | '/app/admin-settings/automatic-background-jobs/table'
    | '/app/admin-settings/logging/$id'
    | '/app/admin-settings/users/$id'
    | '/app/art/activities/$id'
    | '/app/com/chat/$chatId'
    | '/app/contracts/contracts/$id'
    | '/app/duties/leave-requests/$id'
    | '/app/duties/leave-requests/event-log'
    | '/app/my/absences/$id'
    | '/app/my/absences/new-leave-request'
    | '/app/my/absences/successfully-send'
    | '/authenticate/mfa/$id/register'
    | '/authenticate/mfa/$id/validate'
    | '/app/admin-settings/absences'
    | '/app/admin-settings/automatic-background-jobs'
    | '/app/admin-settings/global-settings'
    | '/app/admin-settings/info'
    | '/app/admin-settings/logging'
    | '/app/admin-settings/organisation'
    | '/app/admin-settings/users'
    | '/app/art/activities'
    | '/app/art/productions'
    | '/app/com/chat'
    | '/app/com/feeds'
    | '/app/contacts/$id'
    | '/app/contacts/call'
    | '/app/contacts/create-memo'
    | '/app/contracts/approvals'
    | '/app/contracts/contracts'
    | '/app/duties/absences'
    | '/app/duties/leave-requests'
    | '/app/duties/orchestra'
    | '/app/duties/shifts-and-casts'
    | '/app/my/absences'
    | '/app/my/calendar'
    | '/app/my/duty-roster'
    | '/app/admin-settings/global-settings/docusign/consented'
    | '/app/admin-settings/users/new/external-service-user'
    | '/app/admin-settings/users/new/user-for-person'
    | '/app/admin-settings/users/new/users-for-persons'
    | '/app/com/feeds/$feedId/$postId'
    | '/app/contracts/approvals/$contractId/signed'
    | '/app/duties/leave-requests/debug-view/$id'
    | '/app/admin-settings/users/new'
    | '/app/art/productions/$id'
    | '/app/com/feeds/$feedId'
    | '/app/contracts/approvals/$contractId'
    | '/app/art/productions/$id/$roleId'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/app/account'
    | '/app/admin-settings'
    | '/app/background-jobs'
    | '/app/contacts'
    | '/app/dashboard'
    | '/app/duty-roster'
    | '/app/duty-scheduling'
    | '/app/orchestra'
    | '/app/outbox'
    | '/app/personal-duty-roster'
    | '/app/resources'
    | '/authenticate/login'
    | '/authenticate/password-forgotten'
    | '/authenticate/reset-password'
    | '/authenticate/welcome-set-password'
    | '/version/'
    | '/app/admin-settings/absences'
    | '/app/admin-settings/automatic-background-jobs'
    | '/app/admin-settings/dashboard'
    | '/app/admin-settings/global-settings'
    | '/app/admin-settings/info'
    | '/app/admin-settings/organisation'
    | '/app/admin-settings/users'
    | '/app/art/activities'
    | '/app/art/productions'
    | '/app/art/schedules'
    | '/app/com/chat'
    | '/app/contacts/$id'
    | '/app/contracts/approvals'
    | '/app/contracts/contracts'
    | '/app/duties/absences'
    | '/app/duties/leave-requests'
    | '/app/duties/print'
    | '/app/my/absences'
    | '/app/my/calendar-subscriptions'
    | '/app/my/rapport'
    | '/app/resources/$id'
    | '/app/resources/resource-objects'
    | '/app/resources/resources'
    | '/authenticate/mfa/create'
    | '/authenticate/mfa/select-authentication-factor'
    | '/contract-signing/$contractId/signed'
    | '/app/account/'
    | '/app/admin-settings/'
    | '/app/contacts/'
    | '/app/duties/'
    | '/app/orchestra/'
    | '/app/resources/'
    | '/contract-signing/$contractId/'
    | '/app/admin-settings/absences/$id'
    | '/app/admin-settings/absences/new'
    | '/app/admin-settings/automatic-background-jobs/$id'
    | '/app/admin-settings/automatic-background-jobs/new'
    | '/app/admin-settings/automatic-background-jobs/table'
    | '/app/admin-settings/logging/$id'
    | '/app/admin-settings/users/$id'
    | '/app/admin-settings/users/new'
    | '/app/art/activities/$id'
    | '/app/art/productions/$id'
    | '/app/com/chat/$chatId'
    | '/app/contracts/contracts/$id'
    | '/app/duties/leave-requests/$id'
    | '/app/duties/leave-requests/event-log'
    | '/app/my/absences/$id'
    | '/app/my/absences/new-leave-request'
    | '/app/my/absences/successfully-send'
    | '/authenticate/mfa/$id/register'
    | '/authenticate/mfa/$id/validate'
    | '/app/admin-settings/absences/'
    | '/app/admin-settings/automatic-background-jobs/'
    | '/app/admin-settings/global-settings/'
    | '/app/admin-settings/info/'
    | '/app/admin-settings/logging/'
    | '/app/admin-settings/organisation/'
    | '/app/admin-settings/users/'
    | '/app/art/activities/'
    | '/app/art/productions/'
    | '/app/com/chat/'
    | '/app/com/feeds/'
    | '/app/contacts/$id/'
    | '/app/contacts/call/'
    | '/app/contacts/create-memo/'
    | '/app/contracts/approvals/'
    | '/app/contracts/contracts/'
    | '/app/duties/absences/'
    | '/app/duties/leave-requests/'
    | '/app/duties/orchestra/'
    | '/app/duties/shifts-and-casts/'
    | '/app/my/absences/'
    | '/app/my/calendar/'
    | '/app/my/duty-roster/'
    | '/app/admin-settings/global-settings/docusign/consented'
    | '/app/admin-settings/users/new/external-service-user'
    | '/app/admin-settings/users/new/user-for-person'
    | '/app/admin-settings/users/new/users-for-persons'
    | '/app/com/feeds/$feedId/$postId'
    | '/app/contracts/approvals/$contractId/signed'
    | '/app/duties/leave-requests/debug-view/$id'
    | '/app/admin-settings/users/new/'
    | '/app/art/productions/$id/'
    | '/app/com/feeds/$feedId/'
    | '/app/contracts/approvals/$contractId/'
    | '/app/art/productions/$id/$roleId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AuthenticateLoginRoute: typeof AuthenticateLoginRoute
  AuthenticatePasswordForgottenRoute: typeof AuthenticatePasswordForgottenRoute
  AuthenticateResetPasswordRoute: typeof AuthenticateResetPasswordRoute
  AuthenticateWelcomeSetPasswordRoute: typeof AuthenticateWelcomeSetPasswordRoute
  VersionIndexRoute: typeof VersionIndexRoute
  AuthenticateMfaCreateRoute: typeof AuthenticateMfaCreateRoute
  AuthenticateMfaSelectAuthenticationFactorRoute: typeof AuthenticateMfaSelectAuthenticationFactorRoute
  ContractSigningContractIdSignedRoute: typeof ContractSigningContractIdSignedRoute
  ContractSigningContractIdIndexRoute: typeof ContractSigningContractIdIndexRoute
  AuthenticateMfaIdRegisterRoute: typeof AuthenticateMfaIdRegisterRoute
  AuthenticateMfaIdValidateRoute: typeof AuthenticateMfaIdValidateRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/version/': {
      id: '/version/'
      path: '/version'
      fullPath: '/version'
      preLoaderRoute: typeof VersionIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/authenticate/welcome-set-password': {
      id: '/authenticate/welcome-set-password'
      path: '/authenticate/welcome-set-password'
      fullPath: '/authenticate/welcome-set-password'
      preLoaderRoute: typeof AuthenticateWelcomeSetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/authenticate/reset-password': {
      id: '/authenticate/reset-password'
      path: '/authenticate/reset-password'
      fullPath: '/authenticate/reset-password'
      preLoaderRoute: typeof AuthenticateResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/authenticate/password-forgotten': {
      id: '/authenticate/password-forgotten'
      path: '/authenticate/password-forgotten'
      fullPath: '/authenticate/password-forgotten'
      preLoaderRoute: typeof AuthenticatePasswordForgottenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/authenticate/login': {
      id: '/authenticate/login'
      path: '/authenticate/login'
      fullPath: '/authenticate/login'
      preLoaderRoute: typeof AuthenticateLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/resources': {
      id: '/app/resources'
      path: '/resources'
      fullPath: '/app/resources'
      preLoaderRoute: typeof AppResourcesRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/personal-duty-roster': {
      id: '/app/personal-duty-roster'
      path: '/personal-duty-roster'
      fullPath: '/app/personal-duty-roster'
      preLoaderRoute: typeof AppPersonalDutyRosterRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/outbox': {
      id: '/app/outbox'
      path: '/outbox'
      fullPath: '/app/outbox'
      preLoaderRoute: typeof AppOutboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/orchestra': {
      id: '/app/orchestra'
      path: '/orchestra'
      fullPath: '/app/orchestra'
      preLoaderRoute: typeof AppOrchestraRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/duty-scheduling': {
      id: '/app/duty-scheduling'
      path: '/duty-scheduling'
      fullPath: '/app/duty-scheduling'
      preLoaderRoute: typeof AppDutySchedulingRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/duty-roster': {
      id: '/app/duty-roster'
      path: '/duty-roster'
      fullPath: '/app/duty-roster'
      preLoaderRoute: typeof AppDutyRosterRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/dashboard': {
      id: '/app/dashboard'
      path: '/dashboard'
      fullPath: '/app/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/contacts': {
      id: '/app/contacts'
      path: '/contacts'
      fullPath: '/app/contacts'
      preLoaderRoute: typeof AppContactsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/background-jobs': {
      id: '/app/background-jobs'
      path: '/background-jobs'
      fullPath: '/app/background-jobs'
      preLoaderRoute: typeof AppBackgroundJobsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin-settings': {
      id: '/app/admin-settings'
      path: '/admin-settings'
      fullPath: '/app/admin-settings'
      preLoaderRoute: typeof AppAdminSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/account': {
      id: '/app/account'
      path: '/account'
      fullPath: '/app/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/contract-signing/$contractId/': {
      id: '/contract-signing/$contractId/'
      path: '/contract-signing/$contractId'
      fullPath: '/contract-signing/$contractId'
      preLoaderRoute: typeof ContractSigningContractIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/resources/': {
      id: '/app/resources/'
      path: '/'
      fullPath: '/app/resources/'
      preLoaderRoute: typeof AppResourcesIndexRouteImport
      parentRoute: typeof AppResourcesRoute
    }
    '/app/orchestra/': {
      id: '/app/orchestra/'
      path: '/'
      fullPath: '/app/orchestra/'
      preLoaderRoute: typeof AppOrchestraIndexRouteImport
      parentRoute: typeof AppOrchestraRoute
    }
    '/app/duties/': {
      id: '/app/duties/'
      path: '/duties'
      fullPath: '/app/duties'
      preLoaderRoute: typeof AppDutiesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/contacts/': {
      id: '/app/contacts/'
      path: '/'
      fullPath: '/app/contacts/'
      preLoaderRoute: typeof AppContactsIndexRouteImport
      parentRoute: typeof AppContactsRoute
    }
    '/app/admin-settings/': {
      id: '/app/admin-settings/'
      path: '/'
      fullPath: '/app/admin-settings/'
      preLoaderRoute: typeof AppAdminSettingsIndexRouteImport
      parentRoute: typeof AppAdminSettingsRoute
    }
    '/app/account/': {
      id: '/app/account/'
      path: '/'
      fullPath: '/app/account/'
      preLoaderRoute: typeof AppAccountIndexRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/contract-signing/$contractId/signed': {
      id: '/contract-signing/$contractId/signed'
      path: '/contract-signing/$contractId/signed'
      fullPath: '/contract-signing/$contractId/signed'
      preLoaderRoute: typeof ContractSigningContractIdSignedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/authenticate/mfa/select-authentication-factor': {
      id: '/authenticate/mfa/select-authentication-factor'
      path: '/authenticate/mfa/select-authentication-factor'
      fullPath: '/authenticate/mfa/select-authentication-factor'
      preLoaderRoute: typeof AuthenticateMfaSelectAuthenticationFactorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/authenticate/mfa/create': {
      id: '/authenticate/mfa/create'
      path: '/authenticate/mfa/create'
      fullPath: '/authenticate/mfa/create'
      preLoaderRoute: typeof AuthenticateMfaCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/resources/resources': {
      id: '/app/resources/resources'
      path: '/resources'
      fullPath: '/app/resources/resources'
      preLoaderRoute: typeof AppResourcesResourcesRouteImport
      parentRoute: typeof AppResourcesRoute
    }
    '/app/resources/resource-objects': {
      id: '/app/resources/resource-objects'
      path: '/resource-objects'
      fullPath: '/app/resources/resource-objects'
      preLoaderRoute: typeof AppResourcesResourceObjectsRouteImport
      parentRoute: typeof AppResourcesRoute
    }
    '/app/resources/$id': {
      id: '/app/resources/$id'
      path: '/$id'
      fullPath: '/app/resources/$id'
      preLoaderRoute: typeof AppResourcesIdRouteImport
      parentRoute: typeof AppResourcesRoute
    }
    '/app/my/rapport': {
      id: '/app/my/rapport'
      path: '/my/rapport'
      fullPath: '/app/my/rapport'
      preLoaderRoute: typeof AppMyRapportRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/my/calendar-subscriptions': {
      id: '/app/my/calendar-subscriptions'
      path: '/my/calendar-subscriptions'
      fullPath: '/app/my/calendar-subscriptions'
      preLoaderRoute: typeof AppMyCalendarSubscriptionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/my/absences': {
      id: '/app/my/absences'
      path: '/my/absences'
      fullPath: '/app/my/absences'
      preLoaderRoute: typeof AppMyAbsencesRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/duties/print': {
      id: '/app/duties/print'
      path: '/duties/print'
      fullPath: '/app/duties/print'
      preLoaderRoute: typeof AppDutiesPrintRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/duties/leave-requests': {
      id: '/app/duties/leave-requests'
      path: '/duties/leave-requests'
      fullPath: '/app/duties/leave-requests'
      preLoaderRoute: typeof AppDutiesLeaveRequestsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/duties/absences': {
      id: '/app/duties/absences'
      path: '/duties/absences'
      fullPath: '/app/duties/absences'
      preLoaderRoute: typeof AppDutiesAbsencesRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/contracts/contracts': {
      id: '/app/contracts/contracts'
      path: '/contracts/contracts'
      fullPath: '/app/contracts/contracts'
      preLoaderRoute: typeof AppContractsContractsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/contracts/approvals': {
      id: '/app/contracts/approvals'
      path: '/contracts/approvals'
      fullPath: '/app/contracts/approvals'
      preLoaderRoute: typeof AppContractsApprovalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/contacts/$id': {
      id: '/app/contacts/$id'
      path: '/$id'
      fullPath: '/app/contacts/$id'
      preLoaderRoute: typeof AppContactsIdRouteImport
      parentRoute: typeof AppContactsRoute
    }
    '/app/com/chat': {
      id: '/app/com/chat'
      path: '/com/chat'
      fullPath: '/app/com/chat'
      preLoaderRoute: typeof AppComChatRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/art/schedules': {
      id: '/app/art/schedules'
      path: '/art/schedules'
      fullPath: '/app/art/schedules'
      preLoaderRoute: typeof AppArtSchedulesRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/art/productions': {
      id: '/app/art/productions'
      path: '/art/productions'
      fullPath: '/app/art/productions'
      preLoaderRoute: typeof AppArtProductionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/art/activities': {
      id: '/app/art/activities'
      path: '/art/activities'
      fullPath: '/app/art/activities'
      preLoaderRoute: typeof AppArtActivitiesRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin-settings/users': {
      id: '/app/admin-settings/users'
      path: '/users'
      fullPath: '/app/admin-settings/users'
      preLoaderRoute: typeof AppAdminSettingsUsersRouteImport
      parentRoute: typeof AppAdminSettingsRoute
    }
    '/app/admin-settings/organisation': {
      id: '/app/admin-settings/organisation'
      path: '/organisation'
      fullPath: '/app/admin-settings/organisation'
      preLoaderRoute: typeof AppAdminSettingsOrganisationRouteImport
      parentRoute: typeof AppAdminSettingsRoute
    }
    '/app/admin-settings/info': {
      id: '/app/admin-settings/info'
      path: '/info'
      fullPath: '/app/admin-settings/info'
      preLoaderRoute: typeof AppAdminSettingsInfoRouteImport
      parentRoute: typeof AppAdminSettingsRoute
    }
    '/app/admin-settings/global-settings': {
      id: '/app/admin-settings/global-settings'
      path: '/global-settings'
      fullPath: '/app/admin-settings/global-settings'
      preLoaderRoute: typeof AppAdminSettingsGlobalSettingsRouteImport
      parentRoute: typeof AppAdminSettingsRoute
    }
    '/app/admin-settings/dashboard': {
      id: '/app/admin-settings/dashboard'
      path: '/dashboard'
      fullPath: '/app/admin-settings/dashboard'
      preLoaderRoute: typeof AppAdminSettingsDashboardRouteImport
      parentRoute: typeof AppAdminSettingsRoute
    }
    '/app/admin-settings/automatic-background-jobs': {
      id: '/app/admin-settings/automatic-background-jobs'
      path: '/automatic-background-jobs'
      fullPath: '/app/admin-settings/automatic-background-jobs'
      preLoaderRoute: typeof AppAdminSettingsAutomaticBackgroundJobsRouteImport
      parentRoute: typeof AppAdminSettingsRoute
    }
    '/app/admin-settings/absences': {
      id: '/app/admin-settings/absences'
      path: '/absences'
      fullPath: '/app/admin-settings/absences'
      preLoaderRoute: typeof AppAdminSettingsAbsencesRouteImport
      parentRoute: typeof AppAdminSettingsRoute
    }
    '/app/my/duty-roster/': {
      id: '/app/my/duty-roster/'
      path: '/my/duty-roster'
      fullPath: '/app/my/duty-roster'
      preLoaderRoute: typeof AppMyDutyRosterIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/my/calendar/': {
      id: '/app/my/calendar/'
      path: '/my/calendar'
      fullPath: '/app/my/calendar'
      preLoaderRoute: typeof AppMyCalendarIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/my/absences/': {
      id: '/app/my/absences/'
      path: '/'
      fullPath: '/app/my/absences/'
      preLoaderRoute: typeof AppMyAbsencesIndexRouteImport
      parentRoute: typeof AppMyAbsencesRoute
    }
    '/app/duties/shifts-and-casts/': {
      id: '/app/duties/shifts-and-casts/'
      path: '/duties/shifts-and-casts'
      fullPath: '/app/duties/shifts-and-casts'
      preLoaderRoute: typeof AppDutiesShiftsAndCastsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/duties/orchestra/': {
      id: '/app/duties/orchestra/'
      path: '/duties/orchestra'
      fullPath: '/app/duties/orchestra'
      preLoaderRoute: typeof AppDutiesOrchestraIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/duties/leave-requests/': {
      id: '/app/duties/leave-requests/'
      path: '/'
      fullPath: '/app/duties/leave-requests/'
      preLoaderRoute: typeof AppDutiesLeaveRequestsIndexRouteImport
      parentRoute: typeof AppDutiesLeaveRequestsRoute
    }
    '/app/duties/absences/': {
      id: '/app/duties/absences/'
      path: '/'
      fullPath: '/app/duties/absences/'
      preLoaderRoute: typeof AppDutiesAbsencesIndexRouteImport
      parentRoute: typeof AppDutiesAbsencesRoute
    }
    '/app/contracts/contracts/': {
      id: '/app/contracts/contracts/'
      path: '/'
      fullPath: '/app/contracts/contracts/'
      preLoaderRoute: typeof AppContractsContractsIndexRouteImport
      parentRoute: typeof AppContractsContractsRoute
    }
    '/app/contracts/approvals/': {
      id: '/app/contracts/approvals/'
      path: '/'
      fullPath: '/app/contracts/approvals/'
      preLoaderRoute: typeof AppContractsApprovalsIndexRouteImport
      parentRoute: typeof AppContractsApprovalsRoute
    }
    '/app/contacts/create-memo/': {
      id: '/app/contacts/create-memo/'
      path: '/create-memo'
      fullPath: '/app/contacts/create-memo'
      preLoaderRoute: typeof AppContactsCreateMemoIndexRouteImport
      parentRoute: typeof AppContactsRoute
    }
    '/app/contacts/call/': {
      id: '/app/contacts/call/'
      path: '/call'
      fullPath: '/app/contacts/call'
      preLoaderRoute: typeof AppContactsCallIndexRouteImport
      parentRoute: typeof AppContactsRoute
    }
    '/app/contacts/$id/': {
      id: '/app/contacts/$id/'
      path: '/'
      fullPath: '/app/contacts/$id/'
      preLoaderRoute: typeof AppContactsIdIndexRouteImport
      parentRoute: typeof AppContactsIdRoute
    }
    '/app/com/feeds/': {
      id: '/app/com/feeds/'
      path: '/com/feeds'
      fullPath: '/app/com/feeds'
      preLoaderRoute: typeof AppComFeedsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/com/chat/': {
      id: '/app/com/chat/'
      path: '/'
      fullPath: '/app/com/chat/'
      preLoaderRoute: typeof AppComChatIndexRouteImport
      parentRoute: typeof AppComChatRoute
    }
    '/app/art/productions/': {
      id: '/app/art/productions/'
      path: '/'
      fullPath: '/app/art/productions/'
      preLoaderRoute: typeof AppArtProductionsIndexRouteImport
      parentRoute: typeof AppArtProductionsRoute
    }
    '/app/art/activities/': {
      id: '/app/art/activities/'
      path: '/'
      fullPath: '/app/art/activities/'
      preLoaderRoute: typeof AppArtActivitiesIndexRouteImport
      parentRoute: typeof AppArtActivitiesRoute
    }
    '/app/admin-settings/users/': {
      id: '/app/admin-settings/users/'
      path: '/'
      fullPath: '/app/admin-settings/users/'
      preLoaderRoute: typeof AppAdminSettingsUsersIndexRouteImport
      parentRoute: typeof AppAdminSettingsUsersRoute
    }
    '/app/admin-settings/organisation/': {
      id: '/app/admin-settings/organisation/'
      path: '/'
      fullPath: '/app/admin-settings/organisation/'
      preLoaderRoute: typeof AppAdminSettingsOrganisationIndexRouteImport
      parentRoute: typeof AppAdminSettingsOrganisationRoute
    }
    '/app/admin-settings/logging/': {
      id: '/app/admin-settings/logging/'
      path: '/logging'
      fullPath: '/app/admin-settings/logging'
      preLoaderRoute: typeof AppAdminSettingsLoggingIndexRouteImport
      parentRoute: typeof AppAdminSettingsRoute
    }
    '/app/admin-settings/info/': {
      id: '/app/admin-settings/info/'
      path: '/'
      fullPath: '/app/admin-settings/info/'
      preLoaderRoute: typeof AppAdminSettingsInfoIndexRouteImport
      parentRoute: typeof AppAdminSettingsInfoRoute
    }
    '/app/admin-settings/global-settings/': {
      id: '/app/admin-settings/global-settings/'
      path: '/'
      fullPath: '/app/admin-settings/global-settings/'
      preLoaderRoute: typeof AppAdminSettingsGlobalSettingsIndexRouteImport
      parentRoute: typeof AppAdminSettingsGlobalSettingsRoute
    }
    '/app/admin-settings/automatic-background-jobs/': {
      id: '/app/admin-settings/automatic-background-jobs/'
      path: '/'
      fullPath: '/app/admin-settings/automatic-background-jobs/'
      preLoaderRoute: typeof AppAdminSettingsAutomaticBackgroundJobsIndexRouteImport
      parentRoute: typeof AppAdminSettingsAutomaticBackgroundJobsRoute
    }
    '/app/admin-settings/absences/': {
      id: '/app/admin-settings/absences/'
      path: '/'
      fullPath: '/app/admin-settings/absences/'
      preLoaderRoute: typeof AppAdminSettingsAbsencesIndexRouteImport
      parentRoute: typeof AppAdminSettingsAbsencesRoute
    }
    '/authenticate/mfa/$id/validate': {
      id: '/authenticate/mfa/$id/validate'
      path: '/authenticate/mfa/$id/validate'
      fullPath: '/authenticate/mfa/$id/validate'
      preLoaderRoute: typeof AuthenticateMfaIdValidateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/authenticate/mfa/$id/register': {
      id: '/authenticate/mfa/$id/register'
      path: '/authenticate/mfa/$id/register'
      fullPath: '/authenticate/mfa/$id/register'
      preLoaderRoute: typeof AuthenticateMfaIdRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/my/absences/successfully-send': {
      id: '/app/my/absences/successfully-send'
      path: '/successfully-send'
      fullPath: '/app/my/absences/successfully-send'
      preLoaderRoute: typeof AppMyAbsencesSuccessfullySendRouteImport
      parentRoute: typeof AppMyAbsencesRoute
    }
    '/app/my/absences/new-leave-request': {
      id: '/app/my/absences/new-leave-request'
      path: '/new-leave-request'
      fullPath: '/app/my/absences/new-leave-request'
      preLoaderRoute: typeof AppMyAbsencesNewLeaveRequestRouteImport
      parentRoute: typeof AppMyAbsencesRoute
    }
    '/app/my/absences/$id': {
      id: '/app/my/absences/$id'
      path: '/$id'
      fullPath: '/app/my/absences/$id'
      preLoaderRoute: typeof AppMyAbsencesIdRouteImport
      parentRoute: typeof AppMyAbsencesRoute
    }
    '/app/duties/leave-requests/event-log': {
      id: '/app/duties/leave-requests/event-log'
      path: '/event-log'
      fullPath: '/app/duties/leave-requests/event-log'
      preLoaderRoute: typeof AppDutiesLeaveRequestsEventLogRouteImport
      parentRoute: typeof AppDutiesLeaveRequestsRoute
    }
    '/app/duties/leave-requests/$id': {
      id: '/app/duties/leave-requests/$id'
      path: '/$id'
      fullPath: '/app/duties/leave-requests/$id'
      preLoaderRoute: typeof AppDutiesLeaveRequestsIdRouteImport
      parentRoute: typeof AppDutiesLeaveRequestsRoute
    }
    '/app/contracts/contracts/$id': {
      id: '/app/contracts/contracts/$id'
      path: '/$id'
      fullPath: '/app/contracts/contracts/$id'
      preLoaderRoute: typeof AppContractsContractsIdRouteImport
      parentRoute: typeof AppContractsContractsRoute
    }
    '/app/com/chat/$chatId': {
      id: '/app/com/chat/$chatId'
      path: '/$chatId'
      fullPath: '/app/com/chat/$chatId'
      preLoaderRoute: typeof AppComChatChatIdRouteImport
      parentRoute: typeof AppComChatRoute
    }
    '/app/art/productions/$id': {
      id: '/app/art/productions/$id'
      path: '/$id'
      fullPath: '/app/art/productions/$id'
      preLoaderRoute: typeof AppArtProductionsIdRouteImport
      parentRoute: typeof AppArtProductionsRoute
    }
    '/app/art/activities/$id': {
      id: '/app/art/activities/$id'
      path: '/$id'
      fullPath: '/app/art/activities/$id'
      preLoaderRoute: typeof AppArtActivitiesIdRouteImport
      parentRoute: typeof AppArtActivitiesRoute
    }
    '/app/admin-settings/users/new': {
      id: '/app/admin-settings/users/new'
      path: '/new'
      fullPath: '/app/admin-settings/users/new'
      preLoaderRoute: typeof AppAdminSettingsUsersNewRouteImport
      parentRoute: typeof AppAdminSettingsUsersRoute
    }
    '/app/admin-settings/users/$id': {
      id: '/app/admin-settings/users/$id'
      path: '/$id'
      fullPath: '/app/admin-settings/users/$id'
      preLoaderRoute: typeof AppAdminSettingsUsersIdRouteImport
      parentRoute: typeof AppAdminSettingsUsersRoute
    }
    '/app/admin-settings/logging/$id': {
      id: '/app/admin-settings/logging/$id'
      path: '/logging/$id'
      fullPath: '/app/admin-settings/logging/$id'
      preLoaderRoute: typeof AppAdminSettingsLoggingIdRouteImport
      parentRoute: typeof AppAdminSettingsRoute
    }
    '/app/admin-settings/automatic-background-jobs/table': {
      id: '/app/admin-settings/automatic-background-jobs/table'
      path: '/table'
      fullPath: '/app/admin-settings/automatic-background-jobs/table'
      preLoaderRoute: typeof AppAdminSettingsAutomaticBackgroundJobsTableRouteImport
      parentRoute: typeof AppAdminSettingsAutomaticBackgroundJobsRoute
    }
    '/app/admin-settings/automatic-background-jobs/new': {
      id: '/app/admin-settings/automatic-background-jobs/new'
      path: '/new'
      fullPath: '/app/admin-settings/automatic-background-jobs/new'
      preLoaderRoute: typeof AppAdminSettingsAutomaticBackgroundJobsNewRouteImport
      parentRoute: typeof AppAdminSettingsAutomaticBackgroundJobsRoute
    }
    '/app/admin-settings/automatic-background-jobs/$id': {
      id: '/app/admin-settings/automatic-background-jobs/$id'
      path: '/$id'
      fullPath: '/app/admin-settings/automatic-background-jobs/$id'
      preLoaderRoute: typeof AppAdminSettingsAutomaticBackgroundJobsIdRouteImport
      parentRoute: typeof AppAdminSettingsAutomaticBackgroundJobsRoute
    }
    '/app/admin-settings/absences/new': {
      id: '/app/admin-settings/absences/new'
      path: '/new'
      fullPath: '/app/admin-settings/absences/new'
      preLoaderRoute: typeof AppAdminSettingsAbsencesNewRouteImport
      parentRoute: typeof AppAdminSettingsAbsencesRoute
    }
    '/app/admin-settings/absences/$id': {
      id: '/app/admin-settings/absences/$id'
      path: '/$id'
      fullPath: '/app/admin-settings/absences/$id'
      preLoaderRoute: typeof AppAdminSettingsAbsencesIdRouteImport
      parentRoute: typeof AppAdminSettingsAbsencesRoute
    }
    '/app/contracts/approvals/$contractId/': {
      id: '/app/contracts/approvals/$contractId/'
      path: '/$contractId'
      fullPath: '/app/contracts/approvals/$contractId'
      preLoaderRoute: typeof AppContractsApprovalsContractIdIndexRouteImport
      parentRoute: typeof AppContractsApprovalsRoute
    }
    '/app/com/feeds/$feedId/': {
      id: '/app/com/feeds/$feedId/'
      path: '/com/feeds/$feedId'
      fullPath: '/app/com/feeds/$feedId'
      preLoaderRoute: typeof AppComFeedsFeedIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/art/productions/$id/': {
      id: '/app/art/productions/$id/'
      path: '/'
      fullPath: '/app/art/productions/$id/'
      preLoaderRoute: typeof AppArtProductionsIdIndexRouteImport
      parentRoute: typeof AppArtProductionsIdRoute
    }
    '/app/admin-settings/users/new/': {
      id: '/app/admin-settings/users/new/'
      path: '/'
      fullPath: '/app/admin-settings/users/new/'
      preLoaderRoute: typeof AppAdminSettingsUsersNewIndexRouteImport
      parentRoute: typeof AppAdminSettingsUsersNewRoute
    }
    '/app/duties/leave-requests/debug-view/$id': {
      id: '/app/duties/leave-requests/debug-view/$id'
      path: '/debug-view/$id'
      fullPath: '/app/duties/leave-requests/debug-view/$id'
      preLoaderRoute: typeof AppDutiesLeaveRequestsDebugViewIdRouteImport
      parentRoute: typeof AppDutiesLeaveRequestsRoute
    }
    '/app/contracts/approvals/$contractId/signed': {
      id: '/app/contracts/approvals/$contractId/signed'
      path: '/$contractId/signed'
      fullPath: '/app/contracts/approvals/$contractId/signed'
      preLoaderRoute: typeof AppContractsApprovalsContractIdSignedRouteImport
      parentRoute: typeof AppContractsApprovalsRoute
    }
    '/app/com/feeds/$feedId/$postId': {
      id: '/app/com/feeds/$feedId/$postId'
      path: '/com/feeds/$feedId/$postId'
      fullPath: '/app/com/feeds/$feedId/$postId'
      preLoaderRoute: typeof AppComFeedsFeedIdPostIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin-settings/users/new/users-for-persons': {
      id: '/app/admin-settings/users/new/users-for-persons'
      path: '/users-for-persons'
      fullPath: '/app/admin-settings/users/new/users-for-persons'
      preLoaderRoute: typeof AppAdminSettingsUsersNewUsersForPersonsRouteImport
      parentRoute: typeof AppAdminSettingsUsersNewRoute
    }
    '/app/admin-settings/users/new/user-for-person': {
      id: '/app/admin-settings/users/new/user-for-person'
      path: '/user-for-person'
      fullPath: '/app/admin-settings/users/new/user-for-person'
      preLoaderRoute: typeof AppAdminSettingsUsersNewUserForPersonRouteImport
      parentRoute: typeof AppAdminSettingsUsersNewRoute
    }
    '/app/admin-settings/users/new/external-service-user': {
      id: '/app/admin-settings/users/new/external-service-user'
      path: '/external-service-user'
      fullPath: '/app/admin-settings/users/new/external-service-user'
      preLoaderRoute: typeof AppAdminSettingsUsersNewExternalServiceUserRouteImport
      parentRoute: typeof AppAdminSettingsUsersNewRoute
    }
    '/app/admin-settings/global-settings/docusign/consented': {
      id: '/app/admin-settings/global-settings/docusign/consented'
      path: '/docusign/consented'
      fullPath: '/app/admin-settings/global-settings/docusign/consented'
      preLoaderRoute: typeof AppAdminSettingsGlobalSettingsDocusignConsentedRouteImport
      parentRoute: typeof AppAdminSettingsGlobalSettingsRoute
    }
    '/app/art/productions/$id/$roleId/': {
      id: '/app/art/productions/$id/$roleId/'
      path: '/$roleId'
      fullPath: '/app/art/productions/$id/$roleId'
      preLoaderRoute: typeof AppArtProductionsIdRoleIdIndexRouteImport
      parentRoute: typeof AppArtProductionsIdRoute
    }
  }
}

interface AppAccountRouteChildren {
  AppAccountIndexRoute: typeof AppAccountIndexRoute
}

const AppAccountRouteChildren: AppAccountRouteChildren = {
  AppAccountIndexRoute: AppAccountIndexRoute,
}

const AppAccountRouteWithChildren = AppAccountRoute._addFileChildren(
  AppAccountRouteChildren,
)

interface AppAdminSettingsAbsencesRouteChildren {
  AppAdminSettingsAbsencesIdRoute: typeof AppAdminSettingsAbsencesIdRoute
  AppAdminSettingsAbsencesNewRoute: typeof AppAdminSettingsAbsencesNewRoute
  AppAdminSettingsAbsencesIndexRoute: typeof AppAdminSettingsAbsencesIndexRoute
}

const AppAdminSettingsAbsencesRouteChildren: AppAdminSettingsAbsencesRouteChildren =
  {
    AppAdminSettingsAbsencesIdRoute: AppAdminSettingsAbsencesIdRoute,
    AppAdminSettingsAbsencesNewRoute: AppAdminSettingsAbsencesNewRoute,
    AppAdminSettingsAbsencesIndexRoute: AppAdminSettingsAbsencesIndexRoute,
  }

const AppAdminSettingsAbsencesRouteWithChildren =
  AppAdminSettingsAbsencesRoute._addFileChildren(
    AppAdminSettingsAbsencesRouteChildren,
  )

interface AppAdminSettingsAutomaticBackgroundJobsRouteChildren {
  AppAdminSettingsAutomaticBackgroundJobsIdRoute: typeof AppAdminSettingsAutomaticBackgroundJobsIdRoute
  AppAdminSettingsAutomaticBackgroundJobsNewRoute: typeof AppAdminSettingsAutomaticBackgroundJobsNewRoute
  AppAdminSettingsAutomaticBackgroundJobsTableRoute: typeof AppAdminSettingsAutomaticBackgroundJobsTableRoute
  AppAdminSettingsAutomaticBackgroundJobsIndexRoute: typeof AppAdminSettingsAutomaticBackgroundJobsIndexRoute
}

const AppAdminSettingsAutomaticBackgroundJobsRouteChildren: AppAdminSettingsAutomaticBackgroundJobsRouteChildren =
  {
    AppAdminSettingsAutomaticBackgroundJobsIdRoute:
      AppAdminSettingsAutomaticBackgroundJobsIdRoute,
    AppAdminSettingsAutomaticBackgroundJobsNewRoute:
      AppAdminSettingsAutomaticBackgroundJobsNewRoute,
    AppAdminSettingsAutomaticBackgroundJobsTableRoute:
      AppAdminSettingsAutomaticBackgroundJobsTableRoute,
    AppAdminSettingsAutomaticBackgroundJobsIndexRoute:
      AppAdminSettingsAutomaticBackgroundJobsIndexRoute,
  }

const AppAdminSettingsAutomaticBackgroundJobsRouteWithChildren =
  AppAdminSettingsAutomaticBackgroundJobsRoute._addFileChildren(
    AppAdminSettingsAutomaticBackgroundJobsRouteChildren,
  )

interface AppAdminSettingsGlobalSettingsRouteChildren {
  AppAdminSettingsGlobalSettingsIndexRoute: typeof AppAdminSettingsGlobalSettingsIndexRoute
  AppAdminSettingsGlobalSettingsDocusignConsentedRoute: typeof AppAdminSettingsGlobalSettingsDocusignConsentedRoute
}

const AppAdminSettingsGlobalSettingsRouteChildren: AppAdminSettingsGlobalSettingsRouteChildren =
  {
    AppAdminSettingsGlobalSettingsIndexRoute:
      AppAdminSettingsGlobalSettingsIndexRoute,
    AppAdminSettingsGlobalSettingsDocusignConsentedRoute:
      AppAdminSettingsGlobalSettingsDocusignConsentedRoute,
  }

const AppAdminSettingsGlobalSettingsRouteWithChildren =
  AppAdminSettingsGlobalSettingsRoute._addFileChildren(
    AppAdminSettingsGlobalSettingsRouteChildren,
  )

interface AppAdminSettingsInfoRouteChildren {
  AppAdminSettingsInfoIndexRoute: typeof AppAdminSettingsInfoIndexRoute
}

const AppAdminSettingsInfoRouteChildren: AppAdminSettingsInfoRouteChildren = {
  AppAdminSettingsInfoIndexRoute: AppAdminSettingsInfoIndexRoute,
}

const AppAdminSettingsInfoRouteWithChildren =
  AppAdminSettingsInfoRoute._addFileChildren(AppAdminSettingsInfoRouteChildren)

interface AppAdminSettingsOrganisationRouteChildren {
  AppAdminSettingsOrganisationIndexRoute: typeof AppAdminSettingsOrganisationIndexRoute
}

const AppAdminSettingsOrganisationRouteChildren: AppAdminSettingsOrganisationRouteChildren =
  {
    AppAdminSettingsOrganisationIndexRoute:
      AppAdminSettingsOrganisationIndexRoute,
  }

const AppAdminSettingsOrganisationRouteWithChildren =
  AppAdminSettingsOrganisationRoute._addFileChildren(
    AppAdminSettingsOrganisationRouteChildren,
  )

interface AppAdminSettingsUsersNewRouteChildren {
  AppAdminSettingsUsersNewExternalServiceUserRoute: typeof AppAdminSettingsUsersNewExternalServiceUserRoute
  AppAdminSettingsUsersNewUserForPersonRoute: typeof AppAdminSettingsUsersNewUserForPersonRoute
  AppAdminSettingsUsersNewUsersForPersonsRoute: typeof AppAdminSettingsUsersNewUsersForPersonsRoute
  AppAdminSettingsUsersNewIndexRoute: typeof AppAdminSettingsUsersNewIndexRoute
}

const AppAdminSettingsUsersNewRouteChildren: AppAdminSettingsUsersNewRouteChildren =
  {
    AppAdminSettingsUsersNewExternalServiceUserRoute:
      AppAdminSettingsUsersNewExternalServiceUserRoute,
    AppAdminSettingsUsersNewUserForPersonRoute:
      AppAdminSettingsUsersNewUserForPersonRoute,
    AppAdminSettingsUsersNewUsersForPersonsRoute:
      AppAdminSettingsUsersNewUsersForPersonsRoute,
    AppAdminSettingsUsersNewIndexRoute: AppAdminSettingsUsersNewIndexRoute,
  }

const AppAdminSettingsUsersNewRouteWithChildren =
  AppAdminSettingsUsersNewRoute._addFileChildren(
    AppAdminSettingsUsersNewRouteChildren,
  )

interface AppAdminSettingsUsersRouteChildren {
  AppAdminSettingsUsersIdRoute: typeof AppAdminSettingsUsersIdRoute
  AppAdminSettingsUsersNewRoute: typeof AppAdminSettingsUsersNewRouteWithChildren
  AppAdminSettingsUsersIndexRoute: typeof AppAdminSettingsUsersIndexRoute
}

const AppAdminSettingsUsersRouteChildren: AppAdminSettingsUsersRouteChildren = {
  AppAdminSettingsUsersIdRoute: AppAdminSettingsUsersIdRoute,
  AppAdminSettingsUsersNewRoute: AppAdminSettingsUsersNewRouteWithChildren,
  AppAdminSettingsUsersIndexRoute: AppAdminSettingsUsersIndexRoute,
}

const AppAdminSettingsUsersRouteWithChildren =
  AppAdminSettingsUsersRoute._addFileChildren(
    AppAdminSettingsUsersRouteChildren,
  )

interface AppAdminSettingsRouteChildren {
  AppAdminSettingsAbsencesRoute: typeof AppAdminSettingsAbsencesRouteWithChildren
  AppAdminSettingsAutomaticBackgroundJobsRoute: typeof AppAdminSettingsAutomaticBackgroundJobsRouteWithChildren
  AppAdminSettingsDashboardRoute: typeof AppAdminSettingsDashboardRoute
  AppAdminSettingsGlobalSettingsRoute: typeof AppAdminSettingsGlobalSettingsRouteWithChildren
  AppAdminSettingsInfoRoute: typeof AppAdminSettingsInfoRouteWithChildren
  AppAdminSettingsOrganisationRoute: typeof AppAdminSettingsOrganisationRouteWithChildren
  AppAdminSettingsUsersRoute: typeof AppAdminSettingsUsersRouteWithChildren
  AppAdminSettingsIndexRoute: typeof AppAdminSettingsIndexRoute
  AppAdminSettingsLoggingIdRoute: typeof AppAdminSettingsLoggingIdRoute
  AppAdminSettingsLoggingIndexRoute: typeof AppAdminSettingsLoggingIndexRoute
}

const AppAdminSettingsRouteChildren: AppAdminSettingsRouteChildren = {
  AppAdminSettingsAbsencesRoute: AppAdminSettingsAbsencesRouteWithChildren,
  AppAdminSettingsAutomaticBackgroundJobsRoute:
    AppAdminSettingsAutomaticBackgroundJobsRouteWithChildren,
  AppAdminSettingsDashboardRoute: AppAdminSettingsDashboardRoute,
  AppAdminSettingsGlobalSettingsRoute:
    AppAdminSettingsGlobalSettingsRouteWithChildren,
  AppAdminSettingsInfoRoute: AppAdminSettingsInfoRouteWithChildren,
  AppAdminSettingsOrganisationRoute:
    AppAdminSettingsOrganisationRouteWithChildren,
  AppAdminSettingsUsersRoute: AppAdminSettingsUsersRouteWithChildren,
  AppAdminSettingsIndexRoute: AppAdminSettingsIndexRoute,
  AppAdminSettingsLoggingIdRoute: AppAdminSettingsLoggingIdRoute,
  AppAdminSettingsLoggingIndexRoute: AppAdminSettingsLoggingIndexRoute,
}

const AppAdminSettingsRouteWithChildren =
  AppAdminSettingsRoute._addFileChildren(AppAdminSettingsRouteChildren)

interface AppContactsIdRouteChildren {
  AppContactsIdIndexRoute: typeof AppContactsIdIndexRoute
}

const AppContactsIdRouteChildren: AppContactsIdRouteChildren = {
  AppContactsIdIndexRoute: AppContactsIdIndexRoute,
}

const AppContactsIdRouteWithChildren = AppContactsIdRoute._addFileChildren(
  AppContactsIdRouteChildren,
)

interface AppContactsRouteChildren {
  AppContactsIdRoute: typeof AppContactsIdRouteWithChildren
  AppContactsIndexRoute: typeof AppContactsIndexRoute
  AppContactsCallIndexRoute: typeof AppContactsCallIndexRoute
  AppContactsCreateMemoIndexRoute: typeof AppContactsCreateMemoIndexRoute
}

const AppContactsRouteChildren: AppContactsRouteChildren = {
  AppContactsIdRoute: AppContactsIdRouteWithChildren,
  AppContactsIndexRoute: AppContactsIndexRoute,
  AppContactsCallIndexRoute: AppContactsCallIndexRoute,
  AppContactsCreateMemoIndexRoute: AppContactsCreateMemoIndexRoute,
}

const AppContactsRouteWithChildren = AppContactsRoute._addFileChildren(
  AppContactsRouteChildren,
)

interface AppOrchestraRouteChildren {
  AppOrchestraIndexRoute: typeof AppOrchestraIndexRoute
}

const AppOrchestraRouteChildren: AppOrchestraRouteChildren = {
  AppOrchestraIndexRoute: AppOrchestraIndexRoute,
}

const AppOrchestraRouteWithChildren = AppOrchestraRoute._addFileChildren(
  AppOrchestraRouteChildren,
)

interface AppResourcesRouteChildren {
  AppResourcesIdRoute: typeof AppResourcesIdRoute
  AppResourcesResourceObjectsRoute: typeof AppResourcesResourceObjectsRoute
  AppResourcesResourcesRoute: typeof AppResourcesResourcesRoute
  AppResourcesIndexRoute: typeof AppResourcesIndexRoute
}

const AppResourcesRouteChildren: AppResourcesRouteChildren = {
  AppResourcesIdRoute: AppResourcesIdRoute,
  AppResourcesResourceObjectsRoute: AppResourcesResourceObjectsRoute,
  AppResourcesResourcesRoute: AppResourcesResourcesRoute,
  AppResourcesIndexRoute: AppResourcesIndexRoute,
}

const AppResourcesRouteWithChildren = AppResourcesRoute._addFileChildren(
  AppResourcesRouteChildren,
)

interface AppArtActivitiesRouteChildren {
  AppArtActivitiesIdRoute: typeof AppArtActivitiesIdRoute
  AppArtActivitiesIndexRoute: typeof AppArtActivitiesIndexRoute
}

const AppArtActivitiesRouteChildren: AppArtActivitiesRouteChildren = {
  AppArtActivitiesIdRoute: AppArtActivitiesIdRoute,
  AppArtActivitiesIndexRoute: AppArtActivitiesIndexRoute,
}

const AppArtActivitiesRouteWithChildren =
  AppArtActivitiesRoute._addFileChildren(AppArtActivitiesRouteChildren)

interface AppArtProductionsIdRouteChildren {
  AppArtProductionsIdIndexRoute: typeof AppArtProductionsIdIndexRoute
  AppArtProductionsIdRoleIdIndexRoute: typeof AppArtProductionsIdRoleIdIndexRoute
}

const AppArtProductionsIdRouteChildren: AppArtProductionsIdRouteChildren = {
  AppArtProductionsIdIndexRoute: AppArtProductionsIdIndexRoute,
  AppArtProductionsIdRoleIdIndexRoute: AppArtProductionsIdRoleIdIndexRoute,
}

const AppArtProductionsIdRouteWithChildren =
  AppArtProductionsIdRoute._addFileChildren(AppArtProductionsIdRouteChildren)

interface AppArtProductionsRouteChildren {
  AppArtProductionsIdRoute: typeof AppArtProductionsIdRouteWithChildren
  AppArtProductionsIndexRoute: typeof AppArtProductionsIndexRoute
}

const AppArtProductionsRouteChildren: AppArtProductionsRouteChildren = {
  AppArtProductionsIdRoute: AppArtProductionsIdRouteWithChildren,
  AppArtProductionsIndexRoute: AppArtProductionsIndexRoute,
}

const AppArtProductionsRouteWithChildren =
  AppArtProductionsRoute._addFileChildren(AppArtProductionsRouteChildren)

interface AppComChatRouteChildren {
  AppComChatChatIdRoute: typeof AppComChatChatIdRoute
  AppComChatIndexRoute: typeof AppComChatIndexRoute
}

const AppComChatRouteChildren: AppComChatRouteChildren = {
  AppComChatChatIdRoute: AppComChatChatIdRoute,
  AppComChatIndexRoute: AppComChatIndexRoute,
}

const AppComChatRouteWithChildren = AppComChatRoute._addFileChildren(
  AppComChatRouteChildren,
)

interface AppContractsApprovalsRouteChildren {
  AppContractsApprovalsIndexRoute: typeof AppContractsApprovalsIndexRoute
  AppContractsApprovalsContractIdSignedRoute: typeof AppContractsApprovalsContractIdSignedRoute
  AppContractsApprovalsContractIdIndexRoute: typeof AppContractsApprovalsContractIdIndexRoute
}

const AppContractsApprovalsRouteChildren: AppContractsApprovalsRouteChildren = {
  AppContractsApprovalsIndexRoute: AppContractsApprovalsIndexRoute,
  AppContractsApprovalsContractIdSignedRoute:
    AppContractsApprovalsContractIdSignedRoute,
  AppContractsApprovalsContractIdIndexRoute:
    AppContractsApprovalsContractIdIndexRoute,
}

const AppContractsApprovalsRouteWithChildren =
  AppContractsApprovalsRoute._addFileChildren(
    AppContractsApprovalsRouteChildren,
  )

interface AppContractsContractsRouteChildren {
  AppContractsContractsIdRoute: typeof AppContractsContractsIdRoute
  AppContractsContractsIndexRoute: typeof AppContractsContractsIndexRoute
}

const AppContractsContractsRouteChildren: AppContractsContractsRouteChildren = {
  AppContractsContractsIdRoute: AppContractsContractsIdRoute,
  AppContractsContractsIndexRoute: AppContractsContractsIndexRoute,
}

const AppContractsContractsRouteWithChildren =
  AppContractsContractsRoute._addFileChildren(
    AppContractsContractsRouteChildren,
  )

interface AppDutiesAbsencesRouteChildren {
  AppDutiesAbsencesIndexRoute: typeof AppDutiesAbsencesIndexRoute
}

const AppDutiesAbsencesRouteChildren: AppDutiesAbsencesRouteChildren = {
  AppDutiesAbsencesIndexRoute: AppDutiesAbsencesIndexRoute,
}

const AppDutiesAbsencesRouteWithChildren =
  AppDutiesAbsencesRoute._addFileChildren(AppDutiesAbsencesRouteChildren)

interface AppDutiesLeaveRequestsRouteChildren {
  AppDutiesLeaveRequestsIdRoute: typeof AppDutiesLeaveRequestsIdRoute
  AppDutiesLeaveRequestsEventLogRoute: typeof AppDutiesLeaveRequestsEventLogRoute
  AppDutiesLeaveRequestsIndexRoute: typeof AppDutiesLeaveRequestsIndexRoute
  AppDutiesLeaveRequestsDebugViewIdRoute: typeof AppDutiesLeaveRequestsDebugViewIdRoute
}

const AppDutiesLeaveRequestsRouteChildren: AppDutiesLeaveRequestsRouteChildren =
  {
    AppDutiesLeaveRequestsIdRoute: AppDutiesLeaveRequestsIdRoute,
    AppDutiesLeaveRequestsEventLogRoute: AppDutiesLeaveRequestsEventLogRoute,
    AppDutiesLeaveRequestsIndexRoute: AppDutiesLeaveRequestsIndexRoute,
    AppDutiesLeaveRequestsDebugViewIdRoute:
      AppDutiesLeaveRequestsDebugViewIdRoute,
  }

const AppDutiesLeaveRequestsRouteWithChildren =
  AppDutiesLeaveRequestsRoute._addFileChildren(
    AppDutiesLeaveRequestsRouteChildren,
  )

interface AppMyAbsencesRouteChildren {
  AppMyAbsencesIdRoute: typeof AppMyAbsencesIdRoute
  AppMyAbsencesNewLeaveRequestRoute: typeof AppMyAbsencesNewLeaveRequestRoute
  AppMyAbsencesSuccessfullySendRoute: typeof AppMyAbsencesSuccessfullySendRoute
  AppMyAbsencesIndexRoute: typeof AppMyAbsencesIndexRoute
}

const AppMyAbsencesRouteChildren: AppMyAbsencesRouteChildren = {
  AppMyAbsencesIdRoute: AppMyAbsencesIdRoute,
  AppMyAbsencesNewLeaveRequestRoute: AppMyAbsencesNewLeaveRequestRoute,
  AppMyAbsencesSuccessfullySendRoute: AppMyAbsencesSuccessfullySendRoute,
  AppMyAbsencesIndexRoute: AppMyAbsencesIndexRoute,
}

const AppMyAbsencesRouteWithChildren = AppMyAbsencesRoute._addFileChildren(
  AppMyAbsencesRouteChildren,
)

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRouteWithChildren
  AppAdminSettingsRoute: typeof AppAdminSettingsRouteWithChildren
  AppBackgroundJobsRoute: typeof AppBackgroundJobsRoute
  AppContactsRoute: typeof AppContactsRouteWithChildren
  AppDashboardRoute: typeof AppDashboardRoute
  AppDutyRosterRoute: typeof AppDutyRosterRoute
  AppDutySchedulingRoute: typeof AppDutySchedulingRoute
  AppOrchestraRoute: typeof AppOrchestraRouteWithChildren
  AppOutboxRoute: typeof AppOutboxRoute
  AppPersonalDutyRosterRoute: typeof AppPersonalDutyRosterRoute
  AppResourcesRoute: typeof AppResourcesRouteWithChildren
  AppArtActivitiesRoute: typeof AppArtActivitiesRouteWithChildren
  AppArtProductionsRoute: typeof AppArtProductionsRouteWithChildren
  AppArtSchedulesRoute: typeof AppArtSchedulesRoute
  AppComChatRoute: typeof AppComChatRouteWithChildren
  AppContractsApprovalsRoute: typeof AppContractsApprovalsRouteWithChildren
  AppContractsContractsRoute: typeof AppContractsContractsRouteWithChildren
  AppDutiesAbsencesRoute: typeof AppDutiesAbsencesRouteWithChildren
  AppDutiesLeaveRequestsRoute: typeof AppDutiesLeaveRequestsRouteWithChildren
  AppDutiesPrintRoute: typeof AppDutiesPrintRoute
  AppMyAbsencesRoute: typeof AppMyAbsencesRouteWithChildren
  AppMyCalendarSubscriptionsRoute: typeof AppMyCalendarSubscriptionsRoute
  AppMyRapportRoute: typeof AppMyRapportRoute
  AppDutiesIndexRoute: typeof AppDutiesIndexRoute
  AppComFeedsIndexRoute: typeof AppComFeedsIndexRoute
  AppDutiesOrchestraIndexRoute: typeof AppDutiesOrchestraIndexRoute
  AppDutiesShiftsAndCastsIndexRoute: typeof AppDutiesShiftsAndCastsIndexRoute
  AppMyCalendarIndexRoute: typeof AppMyCalendarIndexRoute
  AppMyDutyRosterIndexRoute: typeof AppMyDutyRosterIndexRoute
  AppComFeedsFeedIdPostIdRoute: typeof AppComFeedsFeedIdPostIdRoute
  AppComFeedsFeedIdIndexRoute: typeof AppComFeedsFeedIdIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRouteWithChildren,
  AppAdminSettingsRoute: AppAdminSettingsRouteWithChildren,
  AppBackgroundJobsRoute: AppBackgroundJobsRoute,
  AppContactsRoute: AppContactsRouteWithChildren,
  AppDashboardRoute: AppDashboardRoute,
  AppDutyRosterRoute: AppDutyRosterRoute,
  AppDutySchedulingRoute: AppDutySchedulingRoute,
  AppOrchestraRoute: AppOrchestraRouteWithChildren,
  AppOutboxRoute: AppOutboxRoute,
  AppPersonalDutyRosterRoute: AppPersonalDutyRosterRoute,
  AppResourcesRoute: AppResourcesRouteWithChildren,
  AppArtActivitiesRoute: AppArtActivitiesRouteWithChildren,
  AppArtProductionsRoute: AppArtProductionsRouteWithChildren,
  AppArtSchedulesRoute: AppArtSchedulesRoute,
  AppComChatRoute: AppComChatRouteWithChildren,
  AppContractsApprovalsRoute: AppContractsApprovalsRouteWithChildren,
  AppContractsContractsRoute: AppContractsContractsRouteWithChildren,
  AppDutiesAbsencesRoute: AppDutiesAbsencesRouteWithChildren,
  AppDutiesLeaveRequestsRoute: AppDutiesLeaveRequestsRouteWithChildren,
  AppDutiesPrintRoute: AppDutiesPrintRoute,
  AppMyAbsencesRoute: AppMyAbsencesRouteWithChildren,
  AppMyCalendarSubscriptionsRoute: AppMyCalendarSubscriptionsRoute,
  AppMyRapportRoute: AppMyRapportRoute,
  AppDutiesIndexRoute: AppDutiesIndexRoute,
  AppComFeedsIndexRoute: AppComFeedsIndexRoute,
  AppDutiesOrchestraIndexRoute: AppDutiesOrchestraIndexRoute,
  AppDutiesShiftsAndCastsIndexRoute: AppDutiesShiftsAndCastsIndexRoute,
  AppMyCalendarIndexRoute: AppMyCalendarIndexRoute,
  AppMyDutyRosterIndexRoute: AppMyDutyRosterIndexRoute,
  AppComFeedsFeedIdPostIdRoute: AppComFeedsFeedIdPostIdRoute,
  AppComFeedsFeedIdIndexRoute: AppComFeedsFeedIdIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthenticateLoginRoute: AuthenticateLoginRoute,
  AuthenticatePasswordForgottenRoute: AuthenticatePasswordForgottenRoute,
  AuthenticateResetPasswordRoute: AuthenticateResetPasswordRoute,
  AuthenticateWelcomeSetPasswordRoute: AuthenticateWelcomeSetPasswordRoute,
  VersionIndexRoute: VersionIndexRoute,
  AuthenticateMfaCreateRoute: AuthenticateMfaCreateRoute,
  AuthenticateMfaSelectAuthenticationFactorRoute:
    AuthenticateMfaSelectAuthenticationFactorRoute,
  ContractSigningContractIdSignedRoute: ContractSigningContractIdSignedRoute,
  ContractSigningContractIdIndexRoute: ContractSigningContractIdIndexRoute,
  AuthenticateMfaIdRegisterRoute: AuthenticateMfaIdRegisterRoute,
  AuthenticateMfaIdValidateRoute: AuthenticateMfaIdValidateRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
